// // // // import React, { useEffect, useState, useContext } from 'react'
// // // // import axios from 'axios'
// // // // import ReactPaginate from 'react-paginate';
// // // // import { useAuth } from './AuthContext';
// // // // import AcademicSessionContext from './AcademicSessionContext';
// // // // import { toast } from 'react-toastify';
// // // // import 'react-toastify/dist/ReactToastify.css';


// // // // function FeeHeadDetails() {

// // // //     const [list, setList] = useState([]);
// // // //     const [data, setData] = useState([]);
// // // //     const [loading, setLoading] = useState(true);
// // // //     const [currentPage, setCurrentPage] = useState(1);
// // // //     // const [totalCount, setTotalCount] = useState(0);
// // // //     const [totalPages, totalPagesGet] = useState("");
// // // //     const [getCategories, setCategories] = useState([]);
// // // //     const [getFeeGroups, setFeeGroups] = useState([]);
// // // //     const [getFeeHeads, setFeeHeads] = useState([]);
// // // //     const { user } = useAuth();
// // // //     const { academicSession } = useContext(AcademicSessionContext);
// // // //       const [expandedGroups, setExpandedGroups] = useState({});
// // // //  const [showData, setShowData] = useState(false);

// // // //     const initialState = {
// // // //         fee_head_id: '',
// // // //         category_id: '',
// // // //         fee_group_id: 0,
// // // //         amount: '',
// // // //         shift: '',
// // // //         session_id: academicSession,
// // // //         campus_id: user.user.campus_id,
// // // //         user_id: user.user.user_id,
// // // //         hidden_id: ''
// // // //     }


// // // //     const [validity, setValidity] = useState({
// // // //         fee_head_id: true,
// // // //         category_id: true,
// // // //         fee_group_id: true,
// // // //         amount: true,
// // // //         shift: true,
// // // //     });


// // // //     const [editFormData, setEditFormData] = useState(initialState);


// // // //     useEffect(() => {
// // // //         if (academicSession) {
// // // //             setEditFormData(prevFormData => ({
// // // //                 ...prevFormData,
// // // //                 session_id: parseInt(academicSession)
// // // //             }));
// // // //         }
// // // //     }, [academicSession]);



// // // //     const validateForm = () => {
// // // //         let isValid = true;
// // // //         // Basic validation rules (customize as per your requirements)
// // // //         if (!editFormData.fee_head_id && !editFormData.fee_head_id.trim()) {
// // // //             setValidity((prevState) => ({ ...prevState, fee_head_id: false }));
// // // //             isValid = false;
// // // //         }
// // // //         if (!editFormData.category_id && !editFormData.category_id.trim()) {
// // // //             setValidity((prevState) => ({ ...prevState, category_id: false }));
// // // //             isValid = false;
// // // //         }

// // // //         // if (!editFormData.fee_group_id && !editFormData.fee_group_id.trim()) {
// // // //         //     setValidity((prevState) => ({ ...prevState, fee_group_id: false }));
// // // //         //     isValid = false;
// // // //         // }

// // // //         if (!editFormData.amount && !editFormData.amount.trim()) {
// // // //             setValidity((prevState) => ({ ...prevState, amount: false }));
// // // //             isValid = false;
// // // //         }

// // // //         if (!editFormData.shift && !editFormData.shift.trim()) {
// // // //             setValidity((prevState) => ({ ...prevState, shift: false }));
// // // //             isValid = false;
// // // //         }

// // // //         return isValid;
// // // //     };


// // // //     const [report, getAllReports] = useState({
// // // //         from_date: '',
// // // //         to_date: '',
// // // //         report_type: ''
// // // //     });


// // // //     const [searchCategoryReport, getSearchCategoryReport] = useState({
// // // //         search: '',
// // // //     });




// // // //     function searchCategory() {
// // // //         fetchData();
// // // //     }


// // // //     const handleKeyDown = (e) => {
// // // //         if (e.key === 'Enter') {
// // // //             getSearchCategoryReport(searchCategoryReport);
// // // //             fetchData();
// // // //         }
// // // //     };




// // // //     function getReport() {
// // // //         if (report.report_type == "pdf") {
// // // //             // pdfReport();
// // // //         } else if (report.report_type == "excel") {
// // // //             // excelReport();
// // // //         }
// // // //     }


// // // //     useEffect(() => {
// // // //         let campus_id = user.user.campus_id;
// // // //         const fetchCategory = (campus_id) => {
// // // //             axios.get(process.env.REACT_APP_API_BASE_URL+`/get-categories/${campus_id}`)
// // // //                 .then(res => {
// // // //                     console.log(res.data.results);
// // // //                     setCategories(res.data.results);
// // // //                 })
// // // //                 .catch(err => console.log(err));
// // // //         };
// // // //         if(user){
// // // //             fetchCategory(campus_id);
// // // //         }
// // // //     }, [user]); // Empty dependency array ensures this effect runs only once, on mount



// // // //  useEffect(() => {
// // // //     const fetchFeeHeads = (campus_id) => {
// // // //         axios.get(process.env.REACT_APP_API_BASE_URL+`/fee-heads/${campus_id}`)
// // // //             .then(res => {
// // // //                 setFeeHeads(res.data.results);
// // // //             })
// // // //             .catch(err => console.log(err));
// // // //     };

// // // //     // Ensure user.campus_id is defined before calling fetchClasses
// // // //     if (user && user.user.campus_id) {
// // // //         fetchFeeHeads(user.user.campus_id);
// // // //     }
// // // // }, [user]); // Dependenci




// // // // useEffect(() => {
// // // //     const getFeeGroups = (campus_id) => {
// // // //         axios.get(process.env.REACT_APP_API_BASE_URL+`/fee-groups/${campus_id}`)
// // // //             .then(res => {
// // // //                 setFeeGroups(res.data.results);
// // // //             })
// // // //             .catch(err => console.log(err));
// // // //     };

// // // //     // Ensure user.campus_id is defined before calling fetchClasses
// // // //     if (user && user.user.campus_id) {
// // // //         getFeeGroups(user.user.campus_id);
// // // //     }
// // // // }, [user]); // Dependenci
    


// // // //     const [totalItem, setTotalItemGet] = useState(10);

// // // //     // const itemsPerPage = 10;

// // // //     useEffect(() => {
// // // //         fetchData();
// // // //     }, [currentPage, totalItem]);





// // // //     const fetchData = () => {
// // // //         axios.get(process.env.REACT_APP_API_BASE_URL+"/fee-head-details-list", {
// // // //             params: {
// // // //                 page: currentPage,
// // // //                 limit: totalItem,
// // // //                 search: searchCategoryReport.search,
// // // //                 campus_id: user.user.campus_id
// // // //             }
// // // //         })
// // // //             .then(res => {
// // // //                 console.log(res.data.results);
// // // //                 setList(res.data.results);
// // // //                 totalPagesGet(res.data.totalPages);
// // // //                 setLoading(false);
// // // //             })
// // // //             .catch(err => console.log(err));
// // // //     };

// // // //     const handlePageChange = ({ selected }) => {
// // // //         setCurrentPage(selected + 1);
// // // //     };

// // // //     const handleTotalItemChange = (event) => {

// // // //         const newValue = event.target.value;
// // // //         setTotalItemGet(newValue);

// // // //     }






// // // //     const handleSubmit = async (e) => {
// // // //         e.preventDefault();
// // // //         if (validateForm()) {
// // // //             try {
// // // //                 const response = await axios.post(process.env.REACT_APP_API_BASE_URL+'/insert-fee-head-details', editFormData, {
// // // //                     headers: {
// // // //                         'Content-Type': 'application/json', // Set content type to JSON
// // // //                     },
// // // //                 });

// // // //                 if (editFormData.hidden_id !== "") {
// // // //                     toast.success('Data updated successfully!');
// // // //                     console.log('Data Updated successfully:', response.data);
// // // //                 } else {
// // // //                     toast.success('Data Inserted successfully!');
// // // //                     console.log('Data Inserted successfully:', response.data);
// // // //                 }

// // // //                 fetchData();
// // // //                 setEditFormData((prevState) => ({
// // // //                     ...prevState,
// // // //                     amount: '',
// // // //                     hidden_id:'',
// // // //                     fee_group_id: 0,
// // // //                   }));
                  

// // // //                 // setEditFormData(initialState); // Reset form data after successful submission

// // // //             } catch (error) {
// // // //                 // console.error('There was an error!', error);
// // // //                 if (error.response && error.response.data && error.response.data.error) {
// // // //                     toast.error(`Error: ${error.response.data.error}`);
// // // //                 }
// // // //             }

           
// // // //         }
// // // //     };



// // // //     const fetchFeeHeadDetails = () => {
// // // //         axios.get(process.env.REACT_APP_API_BASE_URL + `/view-fee-head-details-get/${user.user.campus_id}`)
// // // //             .then(response => {
// // // //                 setData(response.data.data);
// // // //                 setLoading(false);
// // // //                 setShowData(true);
                
// // // //                 // Initialize expanded state for all groups
// // // //                 const groups = [...new Set(response.data.data.map(item => item.fee_group_name))];
// // // //                 const initialExpandedState = {};
// // // //                 groups.forEach(group => {
// // // //                     initialExpandedState[group] = true;
// // // //                 });
// // // //                 setExpandedGroups(initialExpandedState);
// // // //             })
// // // //             .catch(error => {
// // // //                 console.error('Error:', error);
// // // //                 setLoading(false);
// // // //             });
// // // //     };




// // // //     const toggleGroup = (groupName) => {
// // // //         setExpandedGroups(prev => ({
// // // //             ...prev,
// // // //             [groupName]: !prev[groupName]
// // // //         }));
// // // //     };

// // // //     const toggleAllGroups = () => {
// // // //         const allExpanded = Object.values(expandedGroups).every(val => val);
// // // //         const newState = {};
// // // //         Object.keys(expandedGroups).forEach(key => {
// // // //             newState[key] = !allExpanded;
// // // //         });
// // // //         setExpandedGroups(newState);
// // // //     };

// // // //     if (loading) {
// // // //         return <div>Loading fee head details...</div>;
// // // //     }

   

// // // //     // Group data by fee_group_name and then by category
// // // //     const groupedData = data.reduce((acc, item) => {
// // // //         if (!acc[item.fee_group_name]) {
// // // //             acc[item.fee_group_name] = {};
// // // //         }
// // // //         if (!acc[item.fee_group_name][item.category]) {
// // // //             acc[item.fee_group_name][item.category] = [];
// // // //         }
// // // //         acc[item.fee_group_name][item.category].push(item);
// // // //         return acc;
// // // //     }, {});
 



// // // //     const edit = (fee_head_detail_id) => {
// // // //         axios.get(process.env.REACT_APP_API_BASE_URL+`/fee-head-details-get/${fee_head_detail_id}`)
// // // //             .then(response => {
// // // //                 const { id, shift, fee_head_id, category_id, fee_group_id, amount } = response.data.results[0];
// // // //                 console.log(response.data.results[0]);
// // // //                 setEditFormData({...editFormData,
// // // //                     fee_head_id: fee_head_id || '',
// // // //                     category_id: category_id || '',
// // // //                     fee_group_id: fee_group_id || '',
// // // //                     amount: amount || '',
// // // //                     shift: shift || '',
// // // //                     hidden_id: id || ''
// // // //                 });
// // // //             })
// // // //             .catch(error => {
// // // //                 console.error('Error:', error);
// // // //             });
// // // //     }

    

// // // //     const deleteRow = (id_get, status) => {
// // // //         // const confirmDelete = window.confirm('Deleted! Are you sure');
    
// // // //         // if (confirmDelete) {
// // // //           axios
// // // //             .delete(process.env.REACT_APP_API_BASE_URL+`/soft-delete-fee-head-details/${id_get}/${status}`)
// // // //             .then(response => {
// // // //               console.log('Deleted successfully:', response.data);
// // // //               fetchData();
// // // //               // Update the state to remove the deleted item
// // // //             //   setData(prevData => prevData.filter(item => item.id !== id_get));
// // // //             })
// // // //             .catch(error => {
// // // //               console.error('Error deleting item:', error);
// // // //             });
// // // //         // }
// // // //       };






// // // //     return (
// // // //         <>
// // // //             <div className="d-flex">
// // // //                 <div className='col-md-6 p-2'>
// // // //                     <h5 className='text-warning bg-primary p-2 card-header border'> <i className="fas fa-university"></i>Fee Head Detail</h5>
// // // //                     <div className='d-flex justify-content-end  p-2'>
// // // //                         <button className='btn btn-sm btn-warning' onClick={fetchFeeHeadDetails}><i className='fas fa-eye'></i> View Fee Heads Detail</button>
// // // //                     </div>
// // // //                     <form className='border p-3' onSubmit={handleSubmit}>
// // // //                         <div className="form-group row">
// // // //                             <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">Category&nbsp;*</label>
// // // //                             <div className="col-sm-10 ">
// // // //                                 <select name='fee_head_id'
// // // //                                     value={editFormData.category_id}
// // // //                                     onChange={(e) => {
// // // //                                         setEditFormData({ ...editFormData, category_id: e.target.value });
// // // //                                         setValidity({ ...validity, category_id: true });
// // // //                                     }}

// // // //                                     className={validity.category_id ? 'form-control' : 'form-control invalid-input'}  >
// // // //                                     <option value="">Select Category</option>
// // // //                                     {getCategories.map((category, index) => (
// // // //                                         <option key={index} value={category.id}>
// // // //                                             {category.category}
// // // //                                         </option>
// // // //                                     ))}
// // // //                                 </select>

// // // //                             </div>
// // // //                         </div>




// // // //                         <div className="form-group row d-none">
// // // //                             <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">Groups *</label>
// // // //                             <div className="col-sm-10 ">
// // // //                                 <select name='fee_group_id'
// // // //                                     value={editFormData.fee_group_id}
// // // //                                     onChange={(e) => {
// // // //                                         setEditFormData({ ...editFormData, fee_group_id: e.target.value });
// // // //                                         setValidity({ ...validity, fee_group_id: true });
// // // //                                     }}
// // // //                                     className={validity.fee_group_id ? 'form-control' : 'form-control invalid-input'}  >
// // // //                                     <option value="">Select Fee Group</option>
// // // //                                     {getFeeGroups.map((fee_group, index) => (
// // // //                                         <option key={index} value={fee_group.id}>
// // // //                                             {fee_group.fee_group_name}
// // // //                                         </option>
// // // //                                     ))}
// // // //                                 </select>

// // // //                             </div>
// // // //                         </div>


// // // //                         <div className="form-group row">
// // // //                             <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">Shift *</label>
// // // //                             <div className="col-sm-10 ">
// // // //                                 <select name='shift'
// // // //                                     value={editFormData.shift}
// // // //                                     onChange={(e) => {
// // // //                                         setEditFormData({ ...editFormData, shift: e.target.value });
// // // //                                         setValidity({ ...validity, shift: true });
// // // //                                     }}
// // // //                                     className={validity.shift ? 'form-control' : 'form-control invalid-input'}  >
// // // //                                     <option value="">Select Shift</option>
// // // //                                     <option>Morning</option>
// // // //                                     <option>Evening</option>
// // // //                                 </select>

// // // //                             </div>
// // // //                         </div>


// // // //                         <div className="form-group row">
// // // //                             <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">Heads *</label>
// // // //                             <div className="col-sm-10 ">


// // // //                                 <select name='fee_head_id'

// // // //                                     value={editFormData.fee_head_id}
// // // //                                     onChange={(e) => {
// // // //                                         setEditFormData({ ...editFormData, fee_head_id: e.target.value });
// // // //                                         setValidity({ ...validity, fee_head_id: true });
// // // //                                     }}

// // // //                                     className={validity.fee_head_id ? 'form-control' : 'form-control invalid-input'}  >
// // // //                                     <option value="">Select Fee Head</option>
// // // //                                     {getFeeHeads.map((head, index) => (
// // // //                                         <option key={index} value={head.id}>
// // // //                                             {head.head_name}
// // // //                                         </option>
// // // //                                     ))}
// // // //                                 </select>

// // // //                             </div>
// // // //                         </div>
                        


// // // //                         <div className="form-group row">
// // // //                             <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">Amount *</label>
// // // //                             <div className="col-sm-10 ">
// // // //                                 <input
// // // //                                     type="number"
// // // //                                     name='amount'
// // // //                                     value={editFormData.amount}
// // // //                                     onChange={(e) => {
// // // //                                         setEditFormData({ ...editFormData, amount: e.target.value });
// // // //                                         setValidity({ ...validity, amount: true });
// // // //                                     }}
// // // //                                     className={validity.amount ? 'form-control' : 'form-control invalid-input'}
// // // //                                 />
// // // //                             </div>
// // // //                         </div>

// // // //                         <div className="form-group row">
// // // //                             <label htmlFor="inputEmail3" className="col-sm-2 col-form-label"></label>
// // // //                             <div className="col-sm-10 d-flex justify-content-end">
// // // //                                 <input type="submit" className='btn btn-sm btn-primary' value={"Save"} onClick={handleSubmit} />
// // // //                             </div>
// // // //                         </div>

// // // //                     </form>
// // // //                 </div>

// // // //                 <div className='col-md-6 p-2' >


// // // //                     <div className="card-header text-warning bg-primary p-2">
// // // //                         <div className="d-flex justify-content-between align-items-center">
// // // //                             <div>
// // // //                                 <i className="fas fa-list"></i> Fee Head Detail List
// // // //                             </div>


// // // //                             {/* search category */}


// // // //                             <div className="d-flex">
// // // //                                 <div className="me-2 mr-2">
// // // //                                     <input type="text" className="form-control" id="search_category" onKeyDown={handleKeyDown} onChange={(e) => getSearchCategoryReport({ ...searchCategoryReport, search: e.target.value })} />
// // // //                                 </div>
// // // //                                 <button className="btn btn-sm btn-danger" onClick={searchCategory} >Search</button>
// // // //                             </div>




// // // //                             <div className="d-none">
// // // //                                 <div className="me-2 mr-2">
// // // //                                     <input type="date" className="form-control" id="from_date" onChange={(e) => getAllReports({ ...report, from_date: e.target.value })} />
// // // //                                 </div>

// // // //                                 <div className="me-2 mr-2">
// // // //                                     <input type="date" className="form-control" id="to_date" onChange={(e) => getAllReports({ ...report, to_date: e.target.value })} />
// // // //                                 </div>

// // // //                                 <div className="me-2 mr-2">
// // // //                                     <select name="type" id="type" className="form-control" onChange={(e) => getAllReports({ ...report, report_type: e.target.value })}>
// // // //                                         <option value="">Select Type</option>

// // // //                                         <option value="excel">Excel</option>
// // // //                                         <option value="pdf">PDF</option>
// // // //                                     </select>
// // // //                                 </div>

// // // //                                 <button className="btn btn-sm btn-danger" onClick={getReport} >Get Report</button>
// // // //                             </div>



// // // //                         </div>
// // // //                     </div>

// // // //                     <div className='border p-2'>
// // // //                         <div className='pb-3'>
// // // //                             <select value={totalItem} onChange={handleTotalItemChange}>
// // // //                                 <option value="10">10</option>
// // // //                                 <option value="20">20</option>
// // // //                                 <option value="30">30</option>
// // // //                                 <option value="40">40</option>
// // // //                                 <option value="50">50</option>
// // // //                             </select>
// // // //                         </div>


// // // //                         <table className='table'>
// // // //                             <thead>
// // // //                                 <tr>
// // // //                                     {/* <th>ID</th> */}
// // // //                                     <th>Head Name</th>
// // // //                                     <th>Category</th>
// // // //                                     <th style={{display:"none"}}>Groups</th>
// // // //                                     <th>Amount</th>
// // // //                                     <th className='text-center'>Edit</th>
// // // //                                     <th className='text-center'>Status</th>
// // // //                                 </tr>
// // // //                             </thead>
// // // //                             <tbody>
// // // //                                 {loading ? (
// // // //                                     <tr>
// // // //                                         <td colSpan="4">Loading...</td>
// // // //                                     </tr>
// // // //                                 ) : (


// // // //                                     list.map((fee_head_details, index) => (
// // // //                                         <tr key={index}>
// // // //                                             {/* <td>{bank_detail.id}</td> */}
// // // //                                             <td>{fee_head_details.head_name}</td>
// // // //                                             <td>{fee_head_details.category}</td>
// // // //                                             <td style={{display:"none"}}>{fee_head_details.fee_group_name}</td>
// // // //                                             <td>{fee_head_details.amount}</td>
// // // //                                             <td className='text-center'>
// // // //                                                 <div><a href="#" className='btn btn-success btn-sm' onClick={() => edit(fee_head_details.id)} ><i className="fas fa-edit"></i></a></div>
// // // //                                             </td>
// // // //                                             <td className='text-center'>
// // // //                                                 <div><a href="#" className={`btn btn-sm ${fee_head_details.status == 'On' ? 'btn-success' : 'btn-danger'}`} onClick={() => deleteRow(fee_head_details.id, fee_head_details.status)}> <i className={`fas ${fee_head_details.status == 'On' ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i></a></div>
// // // //                                             </td>
// // // //                                         </tr>
// // // //                                     ))
// // // //                                 )}
// // // //                             </tbody>
// // // //                         </table>

// // // //                         <ReactPaginate
// // // //                             previousLabel={'Previous'}
// // // //                             nextLabel={'Next'}
// // // //                             breakLabel={'...'}
// // // //                             pageCount={totalPages}
// // // //                             marginPagesDisplayed={2}
// // // //                             pageRangeDisplayed={3}
// // // //                             onPageChange={handlePageChange}
// // // //                             containerClassName={'pagination'}
// // // //                             pageClassName={'page-item'}
// // // //                             activeClassName={'active'}
// // // //                             pageLinkClassName={'page-link'}
// // // //                             previousClassName={'page-item'}
// // // //                             previousLinkClassName={'page-link'}
// // // //                             nextClassName={'page-item'}
// // // //                             nextLinkClassName={'page-link'}
// // // //                             breakClassName={'page-item'}
// // // //                             breakLinkClassName={'page-link'}
// // // //                         />

// // // //                     </div>

// // // //                 </div>
// // // //             </div>



// // // //  {showData && (
// // // //         <>
// // // //           <div
// // // //             style={{
// // // //               position: "fixed",
// // // //               top: "50%",
// // // //               left: "50%",
// // // //               transform: "translate(-50%, -50%)",
// // // //               zIndex: "100",
// // // //               backdropFilter: "blur(10px)",
// // // //               width: "100%",
// // // //               // maxWidth: "1800px",
// // // //               // maxHeight: "100vh",
// // // //               height:"100vh",
// // // //               backgroundColor: "white",
// // // //               boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
// // // //               padding: "10px",
// // // //               overflow: "hidden",
// // // //             }}
// // // //           >
// // // //             <div
// // // //               style={{
// // // //                 position: "sticky",
// // // //                 top: 0,
// // // //                 zIndex: 101,
// // // //                 backgroundColor: "#EBD197",
// // // //                 color: "black",
// // // //                 padding: "8px 16px",
// // // //               }}
// // // //             >
// // // //               <i className="fas fa-university me-2"></i> Fee Head Details
// // // //               <button
// // // //                 onClick={() => setShowData(false)}
// // // //                 style={{
// // // //                   position: "absolute",
// // // //                   top: "5px",
// // // //                   right: "15px",
// // // //                   background: "transparent",
// // // //                   border: "none",
// // // //                   fontSize: "20px",
// // // //                   cursor: "pointer",
// // // //                   color: "black",
// // // //                 }}
// // // //               >
// // // //                 &times;
// // // //               </button>
// // // //             </div>

// // // //             <div
// // // //               style={{
// // // //                 padding: "20px",
// // // //                 marginTop: "10px",
// // // //                 width: "100%",
// // // //                 overflowY: "auto",
// // // //                 maxHeight: "calc(90vh - 20px)",
// // // //                 paddingTop: "5px",
// // // //               }}
// // // //             >
             
// // // //             <div className="card">
// // // //                 <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                    
// // // //                     <button 
// // // //                         className="btn btn-sm btn-light"
// // // //                         onClick={toggleAllGroups}
// // // //                     >
// // // //                         {Object.values(expandedGroups).every(val => val) ? 'Collapse All' : 'Expand All'}
// // // //                     </button>
// // // //                 </div>
                
// // // //                 <div className="card-body p-0">
// // // //                     {Object.entries(groupedData).map(([groupName, categories]) => (
// // // //                         <div key={groupName} className="mb-3 border-bottom">
// // // //                             <div 
// // // //                                 className="p-3 bg-light d-flex justify-content-between align-items-center cursor-pointer"
// // // //                                 onClick={() => toggleGroup(groupName)}
// // // //                                 style={{ cursor: 'pointer' }}
// // // //                             >
// // // //                                 <h5 className="mb-0 text-primary">
// // // //                                     <i className={`fas fa-${expandedGroups[groupName] ? 'minus' : 'plus'}-circle me-2`}></i>
// // // //                                     {groupName}
// // // //                                 </h5>
// // // //                                 <span className="badge bg-secondary">
// // // //                                     {Object.keys(categories).length} Categories
// // // //                                 </span>
// // // //                             </div>
                            
// // // //                             {expandedGroups[groupName] && (
// // // //                                 <div className="p-2">
// // // //                                     {Object.entries(categories).map(([category, items]) => (
// // // //                                         <div key={category} className="mb-3">
// // // //                                             <div className="p-2 bg-secondary text-white d-flex justify-content-between align-items-center">
// // // //                                                 <h6 className="mb-0">{category}</h6>
// // // //                                                 <span className="badge bg-light text-dark">
// // // //                                                     {items.length} Fee Heads
// // // //                                                 </span>
// // // //                                             </div>
                                            
// // // //                                             <div className="table-responsive">
// // // //                                                 <table className="table table-bordered table-hover mb-0">
// // // //                                                     <thead className="table-light">
// // // //                                                         <tr>
// // // //                                                             <th>Head Name</th>
// // // //                                                             <th>Amount</th>
// // // //                                                             <th>Shift</th>
// // // //                                                             <th>Status</th>
// // // //                                                             <th>Voucher Type</th>
// // // //                                                             <th>Checked Status</th>
// // // //                                                         </tr>
// // // //                                                     </thead>
// // // //                                                     <tbody>
// // // //                                                         {items.map((item, index) => (
// // // //                                                             <tr key={index}>
// // // //                                                                 <td>{item.head_name}</td>
// // // //                                                                 <td>{item.amount}</td>
// // // //                                                                 <td>{item.shift}</td>
// // // //                                                                 <td>
// // // //                                                                     <span className={`badge ${item.status === 'On' ? 'bg-success' : 'bg-danger'}`}>
// // // //                                                                         {item.status}
// // // //                                                                     </span>
// // // //                                                                 </td>
// // // //                                                                 <td>{item.voucher_type}</td>
// // // //                                                                 <td>
// // // //                                                                     {item.checked_status === 'always_checked' ? (
// // // //                                                                         <span className="badge bg-primary">Always Checked</span>
// // // //                                                                     ) : (
// // // //                                                                         <span className="badge bg-warning text-dark">Not Checked</span>
// // // //                                                                     )}
// // // //                                                                 </td>
// // // //                                                             </tr>
// // // //                                                         ))}
// // // //                                                     </tbody>
// // // //                                                     <tfoot>
// // // //                                                         <tr className="table-active">
// // // //                                                             <td colSpan="1" className="text-end fw-bold">Total:</td>
// // // //                                                             <td className="fw-bold">
// // // //                                                                 {items.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)}
// // // //                                                             </td>
// // // //                                                             <td colSpan="4"></td>
// // // //                                                         </tr>
// // // //                                                     </tfoot>
// // // //                                                 </table>
// // // //                                             </div>
// // // //                                         </div>
// // // //                                     ))}
// // // //                                 </div>
// // // //                             )}
// // // //                         </div>
// // // //                     ))}
// // // //                 </div>
// // // //             </div>
// // // //             </div>
// // // //                     </div>
// // // //                      </>
// // // //       )}
// // // //         </>
// // // //     )



// // // // }

// // // // export default FeeHeadDetails



// // // import React, { useEffect, useState, useContext } from 'react';
// // // import axios from 'axios';
// // // import { useAuth } from './AuthContext';
// // // import AcademicSessionContext from './AcademicSessionContext';
// // // import { toast } from 'react-toastify';
// // // import 'react-toastify/dist/ReactToastify.css';

// // // /* ─────────────────────────────────────────────────────────────
// // //    EXACT SAME PATTERN AS AssignSubjects
// // //    Left  = Category cards  (like Class cards)
// // //    Right = Fee heads list + inline form  (like Subjects panel)
// // // ───────────────────────────────────────────────────────────── */

// // // const CSS = `
// // // @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');

// // // .fhd-root { font-family:'DM Sans',sans-serif; padding:16px; background:#f5f7fa; min-height:100vh; }

// // // /* ── Layout ── */
// // // .fhd-layout {
// // //   display:grid;
// // //   grid-template-columns:300px 1fr;
// // //   gap:20px;
// // //   align-items:start;
// // // }
// // // @media(max-width:860px){ .fhd-layout{ grid-template-columns:1fr; } }

// // // /* ══════════════════════════════
// // //    LEFT PANEL  (Category Cards)
// // // ══════════════════════════════ */
// // // .fhd-left {
// // //   background:#fff;
// // //   border:1.5px solid #e0e7ef;
// // //   border-radius:14px;
// // //   overflow:hidden;
// // //   box-shadow:0 2px 12px rgba(30,58,95,.06);
// // // }
// // // .fhd-left-header {
// // //   background:linear-gradient(135deg,#064e3b 0%,#064e3b 100%);
// // //   padding:16px 18px; color:#fff;
// // // }
// // // .fhd-left-header h6 { margin:0; font-size:14px; font-weight:800; color:white; }
// // // .fhd-left-header p  { margin:4px 0 0; font-size:11.5px; opacity:.8; }

// // // .fhd-cat-search { padding:10px 12px; border-bottom:1px solid #f0f4f8; }
// // // .fhd-cat-search input {
// // //   width:100%; border:1.5px solid #e0e7ef; border-radius:8px;
// // //   padding:7px 12px; font-size:13px; font-family:'DM Sans',sans-serif;
// // //   outline:none; transition:.2s;
// // // }
// // // .fhd-cat-search input:focus { border-color:#064e3b; box-shadow:0 0 0 3px rgba(37,99,235,.1); }

// // // .fhd-cat-list {
// // //   max-height:520px; overflow-y:auto; padding:8px;
// // //   display:flex; flex-direction:column; gap:6px;
// // //   scrollbar-width:thin; scrollbar-color:#064e3b transparent;
// // // }

// // // /* Category Card - same as as-class-card */
// // // .fhd-cat-card {
// // //   display:flex; align-items:center; gap:10px;
// // //   padding:10px 12px; border:1.5px solid #f0f4f8;
// // //   border-radius:10px; cursor:pointer;
// // //   transition:all .18s; background:#fff;
// // // }
// // // .fhd-cat-card:hover { border-color:#064e3b; background:#eff6ff; transform:translateX(3px); }
// // // .fhd-cat-card.active {
// // //   border-color:#064e3b; background:#eff6ff;
// // //   box-shadow:0 0 0 3px rgba(37,99,235,.12);
// // // }

// // // .fhd-cat-avatar {
// // //   width:38px; height:38px; flex-shrink:0;
// // //   background:linear-gradient(135deg,#064e3b,#064e3b);
// // //   border-radius:10px; display:flex; align-items:center;
// // //   justify-content:center; font-size:15px; color:#fff; font-weight:800;
// // // }

// // // .fhd-cat-info { flex:1; min-width:0; }
// // // .fhd-cat-name  { font-size:13px; font-weight:700; color:#1e293b; }
// // // .fhd-cat-sub   { font-size:11px; color:#64748b; font-weight:500; margin-top:2px; }

// // // /* Badge - same as as-badge */
// // // .fhd-badge {
// // //   font-size:10px; font-weight:800; padding:3px 9px;
// // //   border-radius:20px; flex-shrink:0; white-space:nowrap;
// // // }
// // // .fhd-badge.set   { background:#dbeafe; color:#064e3b; }
// // // .fhd-badge.empty { background:#f1f5f9; color:#064e3b; }

// // // /* ══════════════════════════════
// // //    RIGHT PANEL
// // // ══════════════════════════════ */
// // // .fhd-right {
// // //   background:#fff;
// // //   border:1.5px solid #e0e7ef;
// // //   border-radius:14px;
// // //   overflow:hidden;
// // //   box-shadow:0 2px 12px rgba(30,58,95,.06);
// // // }

// // // /* Empty state - same as as-empty-state */
// // // .fhd-empty-state {
// // //   display:flex; flex-direction:column; align-items:center;
// // //   justify-content:center; padding:80px 20px;
// // //   color:#94a3b8; text-align:center;
// // // }
// // // .fhd-empty-icon  { font-size:52px; margin-bottom:16px; opacity:.35; }
// // // .fhd-empty-title { font-size:15px; font-weight:700; color:#64748b; margin-bottom:6px; }
// // // .fhd-empty-sub   { font-size:12.5px; }

// // // /* Right header */
// // // .fhd-right-header {
// // //   background:linear-gradient(135deg,#064e3b 0%,#064e3b 100%);
// // //   padding:15px 20px;
// // // }
// // // .fhd-right-header-title { color:#fff; font-size:15px; font-weight:800; }
// // // .fhd-right-header-sub   { color:rgba(255,255,255,.75); font-size:11.5px; margin-top:3px; }

// // // /* Form Section */
// // // .fhd-form-section {
// // //   padding:16px 20px;
// // //   border-bottom:1.5px solid #f0f4f8;
// // //   background:#f8fbff;
// // // }
// // // .fhd-form-label-row {
// // //   display:flex; align-items:center; justify-content:space-between;
// // //   margin-bottom:10px;
// // // }
// // // .fhd-form-section-label {
// // //   font-size:11.5px; font-weight:800; color:#374151;
// // //   text-transform:uppercase; letter-spacing:.6px;
// // //   display:flex; align-items:center; gap:6px;
// // // }
// // // .fhd-edit-pill {
// // //   background:#fef3c7; color:#92400e; border:1.5px solid #fcd34d;
// // //   border-radius:20px; padding:3px 10px; font-size:11px; font-weight:700;
// // //   display:flex; align-items:center; gap:5px;
// // // }
// // // .fhd-edit-pill button {
// // //   background:none; border:none; color:#92400e;
// // //   cursor:pointer; font-size:14px; line-height:1; padding:0; margin-left:2px;
// // // }

// // // .fhd-form-row { display:flex; gap:10px; align-items:flex-end; flex-wrap:wrap; }
// // // .fhd-field { display:flex; flex-direction:column; gap:5px; flex:1; min-width:120px; }
// // // .fhd-field label { font-size:11px; font-weight:700; color:#64748b; text-transform:uppercase; letter-spacing:.4px; }

// // // .fhd-select, .fhd-input {
// // //   padding:9px 12px; border:1.5px solid #e0e7ef; border-radius:9px;
// // //   font-size:13px; color:#1e293b; background:#fff;
// // //   font-family:'DM Sans',sans-serif; outline:none; transition:.2s;
// // // }
// // // .fhd-select:focus, .fhd-input:focus {
// // //   border-color:#064e3b; box-shadow:0 0 0 3px rgba(37,99,235,.1);
// // // }
// // // .fhd-select.err, .fhd-input.err { border-color:#ef4444; box-shadow:0 0 0 3px rgba(239,68,68,.1); }
// // // .fhd-select.ok,  .fhd-input.ok  { border-color:#10b981; }

// // // /* Save button - same as as-save-btn */
// // // .fhd-save-btn {
// // //   background:linear-gradient(135deg,#1e3a5f,#064e3b);
// // //   color:#fff; border:none; border-radius:9px;
// // //   padding:9px 20px; font-size:13px; font-weight:700;
// // //   cursor:pointer; font-family:'DM Sans',sans-serif;
// // //   white-space:nowrap; display:flex; align-items:center; gap:6px;
// // //   transition:opacity .2s,transform .2s; flex-shrink:0;
// // // }
// // // .fhd-save-btn:hover:not(:disabled) { opacity:.9; transform:translateY(-1px); }
// // // .fhd-save-btn:disabled { opacity:.5; cursor:not-allowed; }

// // // .fhd-cancel-btn {
// // //   background:#f1f5f9; color:#64748b; border:none; border-radius:9px;
// // //   padding:9px 16px; font-size:13px; font-weight:700;
// // //   cursor:pointer; font-family:'DM Sans',sans-serif;
// // //   transition:.15s; flex-shrink:0;
// // // }
// // // .fhd-cancel-btn:hover { background:#e2e8f0; }

// // // /* Fee Head List - same as as-subjects-section */
// // // .fhd-list-section { padding:16px 20px; }
// // // .fhd-list-top {
// // //   display:flex; align-items:center; justify-content:space-between;
// // //   margin-bottom:12px;
// // // }
// // // .fhd-list-label {
// // //   font-size:11px; font-weight:800; color:#94a3b8;
// // //   text-transform:uppercase; letter-spacing:.7px;
// // // }
// // // .fhd-search-mini {
// // //   padding:6px 10px; border:1.5px solid #e0e7ef; border-radius:8px;
// // //   font-size:12px; font-family:'DM Sans',sans-serif; outline:none; width:150px;
// // //   transition:.2s;
// // // }
// // // .fhd-search-mini:focus { border-color:#064e3b; }

// // // /* Fee Head Row - same as as-subject-row */
// // // .fhd-head-row {
// // //   display:flex; align-items:center; gap:10px;
// // //   padding:10px 12px; border:1.5px solid #f0f4f8;
// // //   border-radius:10px; margin-bottom:6px; background:#fff;
// // //   transition:border-color .15s;
// // // }
// // // .fhd-head-row:hover { border-color:#dbeafe; background:#f8fbff; }
// // // .fhd-head-row.editing { border-color:#fcd34d; background:#fffbeb; }

// // // .fhd-head-num {
// // //   width:26px; height:26px; border-radius:7px;
// // //   background:#dbeafe; color:#1d4ed8;
// // //   font-size:11px; font-weight:800;
// // //   display:flex; align-items:center; justify-content:center; flex-shrink:0;
// // // }

// // // .fhd-head-info { flex:1; min-width:0; }
// // // .fhd-head-name { font-size:13px; font-weight:700; color:#1e293b; }
// // // .fhd-head-meta { font-size:11px; color:#64748b; margin-top:2px; }

// // // .fhd-head-amount {
// // //   font-size:13px; font-weight:800; color:#1d4ed8;
// // //   background:#eff6ff; padding:4px 10px; border-radius:7px; flex-shrink:0;
// // // }

// // // .fhd-status-badge {
// // //   font-size:10.5px; font-weight:700; padding:3px 9px;
// // //   border-radius:20px; flex-shrink:0;
// // // }
// // // .fhd-status-badge.on  { background:#dcfce7; color:#15803d; }
// // // .fhd-status-badge.off { background:#fee2e2; color:#991b1b; }

// // // .fhd-row-actions { display:flex; gap:5px; flex-shrink:0; }
// // // .fhd-action-btn {
// // //   width:28px; height:28px; border:none; border-radius:7px;
// // //   cursor:pointer; display:flex; align-items:center; justify-content:center;
// // //   font-size:12px; transition:all .15s;
// // // }
// // // .fhd-action-btn:hover { transform:scale(1.1); }
// // // .fhd-btn-edit        { background:#eff6ff; color:#2563eb; }
// // // .fhd-btn-toggle-on   { background:#dcfce7; color:#15803d; }
// // // .fhd-btn-toggle-off  { background:#fee2e2; color:#991b1b; }

// // // .fhd-loading { text-align:center; padding:40px; color:#94a3b8; font-size:13px; }
// // // .fhd-no-heads {
// // //   text-align:center; padding:30px; color:#94a3b8;
// // //   font-size:13px; background:#f9fafb;
// // //   border-radius:10px; border:1.5px dashed #e2e8f0;
// // // }

// // // /* Skeleton */
// // // .fhd-skeleton {
// // //   border-radius:6px; height:13px;
// // //   background:linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 50%,#f1f5f9 75%);
// // //   background-size:200% 100%;
// // //   animation:shimmer 1.5s infinite;
// // // }
// // // @keyframes shimmer{ 0%{background-position:200% 0}100%{background-position:-200% 0} }
// // // `;

// // // function FeeHeadDetails() {
// // //   const { user } = useAuth();
// // //   const { academicSession } = useContext(AcademicSessionContext);
// // //   const campus_id = user?.user?.campus_id;

// // //   // ── Data states ───────────────────────────────────
// // //   const [getCategories, setCategories]  = useState([]);
// // //   const [getFeeHeads,   setFeeHeads]    = useState([]);
// // //   const [assignedMap,   setAssignedMap] = useState({}); // {category_id: count}

// // //   // ── Panel states (same as AssignSubjects) ─────────
// // //   const [selectedCategory, setSelectedCategory] = useState(null);
// // //   const [cardFeeHeads,     setCardFeeHeads]      = useState([]);
// // //   const [loadingCard,      setLoadingCard]        = useState(false);
// // //   const [saving,           setSaving]             = useState(false);

// // //   // ── Search ────────────────────────────────────────
// // //   const [catSearch,  setCatSearch]  = useState('');
// // //   const [listSearch, setListSearch] = useState('');

// // //   // ── Form ──────────────────────────────────────────
// // //   const emptyForm = { fee_head_id:'', shift:'', amount:'', hidden_id:'' };
// // //   const [form,     setForm]     = useState(emptyForm);
// // //   const [validity, setValidity] = useState({ fee_head_id:true, shift:true, amount:true });
// // //   const isEditing = form.hidden_id !== '';

// // //   // ── Fetch categories ──────────────────────────────
// // //   useEffect(() => {
// // //     if (!campus_id) return;
// // //     axios.get(`${process.env.REACT_APP_API_BASE_URL}/get-categories/${campus_id}`)
// // //       .then(res => setCategories(res.data.results))
// // //       .catch(console.error);
// // //   }, [campus_id]);

// // //   // ── Fetch fee head dropdown options ───────────────
// // //   useEffect(() => {
// // //     if (!campus_id) return;
// // //     axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-heads/${campus_id}`)
// // //       .then(res => setFeeHeads(res.data.results))
// // //       .catch(console.error);
// // //   }, [campus_id]);

// // //   // ── Build assignedMap (same concept as AssignSubjects)
// // //   //    Tells left panel which categories have records ─
// // //   useEffect(() => {
// // //     if (!campus_id) return;
// // //     axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-head-details-list`, {
// // //       params: { page:1, limit:500, campus_id }
// // //     }).then(res => {
// // //       const map = {};
// // //       res.data.results.forEach(item => {
// // //         map[item.category_id] = (map[item.category_id] || 0) + 1;
// // //       });
// // //       setAssignedMap(map);
// // //     }).catch(console.error);
// // //   }, [campus_id]);

// // //   // ── Click category card (same as handleCardClick) ─
// // //   const handleCategoryClick = (cat) => {
// // //     setSelectedCategory({ category_id: cat.id, label: cat.category });
// // //     setForm(emptyForm);
// // //     setLoadingCard(true);

// // //     axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-head-details-list`, {
// // //       params: { page:1, limit:200, campus_id, category_id: cat.id }
// // //     }).then(res => {
// // //       setCardFeeHeads(res.data.results);
// // //       setLoadingCard(false);
// // //     }).catch(err => { console.error(err); setLoadingCard(false); });
// // //   };

// // //   // ── Validate ──────────────────────────────────────
// // //   const validate = () => {
// // //     const v = {
// // //       fee_head_id: !!form.fee_head_id,
// // //       shift:       !!form.shift,
// // //       amount:      !!form.amount && String(form.amount).trim() !== '',
// // //     };
// // //     setValidity(v);
// // //     return Object.values(v).every(Boolean);
// // //   };

// // //   // ── Save / Update (same flow as handleSave) ───────
// // //   const handleSave = async () => {
// // //     if (!selectedCategory) return;
// // //     if (!validate()) { toast.warning('Please fill all fields'); return; }
// // //     setSaving(true);
// // //     try {
// // //       await axios.post(
// // //         `${process.env.REACT_APP_API_BASE_URL}/insert-fee-head-details`,
// // //         {
// // //           fee_head_id:  form.fee_head_id,
// // //           category_id:  selectedCategory.category_id,
// // //           fee_group_id: 0,
// // //           shift:        form.shift,
// // //           amount:       form.amount,
// // //           session_id:   parseInt(academicSession),
// // //           campus_id,
// // //           user_id:      user?.user?.user_id,
// // //           hidden_id:    form.hidden_id,
// // //         },
// // //         { headers: { 'Content-Type': 'application/json' } }
// // //       );

// // //       toast.success(isEditing ? '✅ Record updated!' : '✅ Fee head added!');
// // //       setForm(emptyForm);

// // //       // Re-fetch this card's data (same as AssignSubjects re-fetch after save)
// // //       const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-head-details-list`, {
// // //         params: { page:1, limit:200, campus_id, category_id: selectedCategory.category_id }
// // //       });
// // //       setCardFeeHeads(res.data.results);

// // //       // Update left badge count (same as setAssignedMap after save)
// // //       setAssignedMap(prev => ({
// // //         ...prev,
// // //         [selectedCategory.category_id]: res.data.results.length
// // //       }));

// // //     } catch (error) {
// // //       toast.error(error.response?.data?.error || 'Something went wrong');
// // //     }
// // //     setSaving(false);
// // //   };

// // //   // ── Edit — fills form inline ───────────────────────
// // //   const handleEdit = (item) => {
// // //     setForm({
// // //       fee_head_id: item.fee_head_id || '',
// // //       shift:       item.shift       || '',
// // //       amount:      item.amount      || '',
// // //       hidden_id:   item.id          || '',
// // //     });
// // //     toast.info('✏️ Edit mode — update the form above');
// // //   };

// // //   // ── Toggle status (optimistic update — same as delete in AssignSubjects)
// // //   const handleToggle = (id, currentStatus) => {
// // //     // Optimistic update first
// // //     setCardFeeHeads(prev =>
// // //       prev.map(item =>
// // //         item.id === id
// // //           ? { ...item, status: currentStatus === 'On' ? 'Off' : 'On' }
// // //           : item
// // //       )
// // //     );
// // //     axios.delete(`${process.env.REACT_APP_API_BASE_URL}/soft-delete-fee-head-details/${id}/${currentStatus}`)
// // //       .catch(err => {
// // //         // Rollback on failure
// // //         setCardFeeHeads(prev =>
// // //           prev.map(item => item.id === id ? { ...item, status: currentStatus } : item)
// // //         );
// // //         console.error(err);
// // //       });
// // //   };

// // //   // ── Filtered lists ────────────────────────────────
// // //   const filteredCats = getCategories.filter(c =>
// // //     c.category?.toLowerCase().includes(catSearch.toLowerCase())
// // //   );
// // //   const filteredHeads = cardFeeHeads.filter(h =>
// // //     h.head_name?.toLowerCase().includes(listSearch.toLowerCase()) ||
// // //     h.shift?.toLowerCase().includes(listSearch.toLowerCase())
// // //   );

// // //   // Field class helper
// // //   const fc = (field) => {
// // //     if (!validity[field]) return 'err';
// // //     if (form[field])      return 'ok';
// // //     return '';
// // //   };

// // //   return (
// // //     <>
// // //       <style>{CSS}</style>
// // //       <div className="fhd-root">
// // //         <div className="fhd-layout">

// // //           {/* ══════════════════════════════════════
// // //               LEFT PANEL — Category Cards
// // //               (same structure as Class Cards)
// // //           ══════════════════════════════════════ */}
// // //           <div className="fhd-left">
// // //             <div className="fhd-left-header">
// // //               <h6>📂 Categories</h6>
// // //               <p>Click a category to manage its fee heads</p>
// // //             </div>

// // //             <div className="fhd-cat-search">
// // //               <input
// // //                 type="text"
// // //                 placeholder="🔍 Search category..."
// // //                 value={catSearch}
// // //                 onChange={e => setCatSearch(e.target.value)}
// // //               />
// // //             </div>

// // //             <div className="fhd-cat-list">
// // //               {filteredCats.length === 0 ? (
// // //                 <div style={{textAlign:'center',padding:20,color:'#94a3b8',fontSize:13}}>
// // //                   No categories found
// // //                 </div>
// // //               ) : filteredCats.map((cat, i) => {
// // //                 const isActive = selectedCategory?.category_id === cat.id;
// // //                 const count    = assignedMap[cat.id] || 0;
// // //                 return (
// // //                   <div
// // //                     key={i}
// // //                     className={`fhd-cat-card ${isActive ? 'active' : ''}`}
// // //                     onClick={() => handleCategoryClick(cat)}
// // //                   >
// // //                     {/* Avatar with first letter — same as as-class-avatar */}
// // //                     <div className="fhd-cat-avatar">
// // //                       {cat.category?.charAt(0).toUpperCase()}
// // //                     </div>

// // //                     <div className="fhd-cat-info">
// // //                       <div className="fhd-cat-name">{cat.category}</div>
// // //                       <div className="fhd-cat-sub">
// // //                         {count > 0 ? `${count} fee head${count > 1 ? 's' : ''} configured` : 'No fee heads yet'}
// // //                       </div>
// // //                     </div>

// // //                     {/* Badge — same as ✓ Set / Empty */}
// // //                     <span className={`fhd-badge ${count > 0 ? 'set' : 'empty'}`}>
// // //                       {count > 0 ? `✓ ${count}` : 'Empty'}
// // //                     </span>
// // //                   </div>
// // //                 );
// // //               })}
// // //             </div>
// // //           </div>

// // //           {/* ══════════════════════════════════════
// // //               RIGHT PANEL — Manage Fee Heads
// // //               (same structure as Manage Subjects)
// // //           ══════════════════════════════════════ */}
// // //           <div className="fhd-right">

// // //             {/* Phase 1 — Nothing selected (same as AssignSubjects empty state) */}
// // //             {!selectedCategory ? (
// // //               <div className="fhd-empty-state">
// // //                 <div className="fhd-empty-icon">👈</div>
// // //                 <div className="fhd-empty-title">Select a category first</div>
// // //                 <div className="fhd-empty-sub">
// // //                   Click any category from the left panel<br/>
// // //                   to assign or manage its fee heads
// // //                 </div>
// // //               </div>
// // //             ) : (
// // //               <>
// // //                 {/* Right Header */}
// // //                 <div className="fhd-right-header">
// // //                   <div className="fhd-right-header-title">🏷️ {selectedCategory.label}</div>
// // //                   <div className="fhd-right-header-sub">
// // //                     {loadingCard
// // //                       ? 'Loading...'
// // //                       : `${cardFeeHeads.length} fee head${cardFeeHeads.length !== 1 ? 's' : ''} configured`
// // //                     }
// // //                   </div>
// // //                 </div>

// // //                 {/* ── Add / Edit Form
// // //                     Same as "Add New Subjects" section ── */}
// // //                 <div className="fhd-form-section">
// // //                   <div className="fhd-form-label-row">
// // //                     <div className="fhd-form-section-label">
// // //                       {isEditing ? '✏️ Edit Fee Head' : '➕ Add New Fee Head'}
// // //                     </div>
// // //                     {isEditing && (
// // //                       <div className="fhd-edit-pill">
// // //                         Editing record
// // //                         <button onClick={() => setForm(emptyForm)}>×</button>
// // //                       </div>
// // //                     )}
// // //                   </div>

// // //                   <div className="fhd-form-row">
// // //                     {/* Shift */}
// // //                     <div className="fhd-field">
// // //                       <label>Shift *</label>
// // //                       <select
// // //                         className={`fhd-select ${fc('shift')}`}
// // //                         value={form.shift}
// // //                         onChange={e => {
// // //                           setForm(f => ({...f, shift: e.target.value}));
// // //                           setValidity(v => ({...v, shift: true}));
// // //                         }}
// // //                       >
// // //                         <option value="">— Select —</option>
// // //                         <option>Morning</option>
// // //                         <option>Evening</option>
// // //                       </select>
// // //                     </div>

// // //                     {/* Fee Head */}
// // //                     <div className="fhd-field">
// // //                       <label>Fee Head *</label>
// // //                       <select
// // //                         className={`fhd-select ${fc('fee_head_id')}`}
// // //                         value={form.fee_head_id}
// // //                         onChange={e => {
// // //                           setForm(f => ({...f, fee_head_id: e.target.value}));
// // //                           setValidity(v => ({...v, fee_head_id: true}));
// // //                         }}
// // //                       >
// // //                         <option value="">— Select Head —</option>
// // //                         {getFeeHeads.map((h, i) => (
// // //                           <option key={i} value={h.id}>{h.head_name}</option>
// // //                         ))}
// // //                       </select>
// // //                     </div>

// // //                     {/* Amount */}
// // //                     <div className="fhd-field">
// // //                       <label>Amount (PKR) *</label>
// // //                       <input
// // //                         type="number"
// // //                         min="0"
// // //                         placeholder="e.g. 5000"
// // //                         className={`fhd-input ${fc('amount')}`}
// // //                         value={form.amount}
// // //                         onChange={e => {
// // //                           setForm(f => ({...f, amount: e.target.value}));
// // //                           setValidity(v => ({...v, amount: true}));
// // //                         }}
// // //                       />
// // //                     </div>

// // //                     {/* Buttons */}
// // //                     <div style={{display:'flex', gap:8, alignItems:'flex-end', flexShrink:0}}>
// // //                       {isEditing && (
// // //                         <button className="fhd-cancel-btn" onClick={() => setForm(emptyForm)}>
// // //                           Cancel
// // //                         </button>
// // //                       )}
// // //                       <button
// // //                         className="fhd-save-btn"
// // //                         onClick={handleSave}
// // //                         disabled={saving}
// // //                       >
// // //                         <i className={`fas fa-${saving ? 'spinner fa-spin' : isEditing ? 'save' : 'plus-circle'}`} />
// // //                         {saving ? 'Saving...' : isEditing ? 'Update' : 'Add'}
// // //                       </button>
// // //                     </div>
// // //                   </div>
// // //                 </div>

// // //                 {/* ── Fee Heads List
// // //                     Same as "Currently Assigned Subjects" section ── */}
// // //                 <div className="fhd-list-section">
// // //                   <div className="fhd-list-top">
// // //                     <div className="fhd-list-label">Assigned Fee Heads</div>
// // //                     {cardFeeHeads.length > 0 && (
// // //                       <input
// // //                         type="text"
// // //                         className="fhd-search-mini"
// // //                         placeholder="🔍 Filter..."
// // //                         value={listSearch}
// // //                         onChange={e => setListSearch(e.target.value)}
// // //                       />
// // //                     )}
// // //                   </div>

// // //                   {/* Phase 2 — Loading skeleton */}
// // //                   {loadingCard ? (
// // //                     Array(3).fill(0).map((_, i) => (
// // //                       <div key={i} className="fhd-head-row" style={{gap:12}}>
// // //                         <div className="fhd-skeleton" style={{width:26,height:26,borderRadius:7,flexShrink:0}}/>
// // //                         <div style={{flex:1}}>
// // //                           <div className="fhd-skeleton" style={{width:'60%',marginBottom:6}}/>
// // //                           <div className="fhd-skeleton" style={{width:'35%',height:10}}/>
// // //                         </div>
// // //                         <div className="fhd-skeleton" style={{width:70,height:26,borderRadius:7}}/>
// // //                       </div>
// // //                     ))

// // //                   /* Phase 3a — Empty */
// // //                   ) : cardFeeHeads.length === 0 ? (
// // //                     <div className="fhd-no-heads">
// // //                       No fee heads assigned yet.<br/>
// // //                       Use the form above to add fee heads for <strong>{selectedCategory.label}</strong>.
// // //                     </div>

// // //                   /* Phase 3b — Content (same row as as-subject-row) */
// // //                   ) : filteredHeads.map((item, index) => (
// // //                     <div
// // //                       key={index}
// // //                       className={`fhd-head-row ${form.hidden_id === item.id ? 'editing' : ''}`}
// // //                     >
// // //                       {/* Number — same as as-subject-num */}
// // //                       <div className="fhd-head-num">{index + 1}</div>

// // //                       {/* Info */}
// // //                       <div className="fhd-head-info">
// // //                         <div className="fhd-head-name">{item.head_name}</div>
// // //                         <div className="fhd-head-meta">
// // //                           <i className="fas fa-clock" style={{marginRight:4,fontSize:10}}/>
// // //                           {item.shift}
// // //                         </div>
// // //                       </div>

// // //                       {/* Amount pill */}
// // //                       <div className="fhd-head-amount">
// // //                         Rs. {Number(item.amount).toLocaleString()}
// // //                       </div>

// // //                       {/* Status badge */}
// // //                       <span className={`fhd-status-badge ${item.status === 'On' ? 'on' : 'off'}`}>
// // //                         {item.status === 'On' ? '● Active' : '● Inactive'}
// // //                       </span>

// // //                       {/* Actions — same as delete button in AssignSubjects */}
// // //                       <div className="fhd-row-actions">
// // //                         <button
// // //                           className="fhd-action-btn fhd-btn-edit"
// // //                           onClick={() => handleEdit(item)}
// // //                           title="Edit this record"
// // //                         >
// // //                           <i className="fas fa-pen"/>
// // //                         </button>
// // //                         <button
// // //                           className={`fhd-action-btn ${item.status === 'On' ? 'fhd-btn-toggle-on' : 'fhd-btn-toggle-off'}`}
// // //                           onClick={() => handleToggle(item.id, item.status)}
// // //                           title={item.status === 'On' ? 'Deactivate' : 'Activate'}
// // //                         >
// // //                           <i className={`fas fa-toggle-${item.status === 'On' ? 'on' : 'off'}`}/>
// // //                         </button>
// // //                       </div>
// // //                     </div>
// // //                   ))}
// // //                 </div>
// // //               </>
// // //             )}
// // //           </div>

// // //         </div>
// // //       </div>
// // //     </>
// // //   );
// // // }

// // // export default FeeHeadDetails;






// // import React, { useEffect, useState, useContext } from 'react';
// // import axios from 'axios';
// // import { useAuth } from './AuthContext';
// // import AcademicSessionContext from './AcademicSessionContext';
// // import { toast } from 'react-toastify';
// // import 'react-toastify/dist/ReactToastify.css';

// // /* ─────────────────────────────────────────────────────────────
// //    EXACT SAME PATTERN AS AssignSubjects
// //    Left  = Category cards  (like Class cards)
// //    Right = Fee heads list + inline form  (like Subjects panel)
// // ───────────────────────────────────────────────────────────── */

// // const CSS = `
// // @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');

// // .fhd-root { font-family:'DM Sans',sans-serif; padding:16px; background:#f0fdf4; min-height:100vh; }

// // /* ── Layout ── */
// // .fhd-layout {
// //   display:grid;
// //   grid-template-columns:300px 1fr;
// //   gap:20px;
// //   align-items:start;
// // }
// // @media(max-width:860px){ .fhd-layout{ grid-template-columns:1fr; } }

// // /* ══════════════════════════════
// //    LEFT PANEL  (Category Cards)
// // ══════════════════════════════ */
// // .fhd-left {
// //   background:#fff;
// //   border:1.5px solid #e0e7ef;
// //   border-radius:14px;
// //   overflow:hidden;
// //   box-shadow:0 2px 12px rgba(30,58,95,.06);
// // }
// // .fhd-left-header {
// //   background:#064e3b;
// //   padding:16px 18px; color:#fff;
// // }
// // .fhd-left-header h6 { margin:0; font-size:14px; font-weight:800; }
// // .fhd-left-header p  { margin:4px 0 0; font-size:11.5px; opacity:.8; }

// // .fhd-cat-search { padding:10px 12px; border-bottom:1px solid #f0f4f8; }
// // .fhd-cat-search input {
// //   width:100%; border:1.5px solid #e0e7ef; border-radius:8px;
// //   padding:7px 12px; font-size:13px; font-family:'DM Sans',sans-serif;
// //   outline:none; transition:.2s;
// // }
// // .fhd-cat-search input:focus { border-color:#064e3b; box-shadow:0 0 0 3px rgba(6,78,59,.12); }

// // .fhd-cat-list {
// //   max-height:520px; overflow-y:auto; padding:8px;
// //   display:flex; flex-direction:column; gap:6px;
// //   scrollbar-width:thin; scrollbar-color:#6ee7b7 transparent;
// // }

// // /* Category Card - same as as-class-card */
// // .fhd-cat-card {
// //   display:flex; align-items:center; gap:10px;
// //   padding:10px 12px; border:1.5px solid #f0f4f8;
// //   border-radius:10px; cursor:pointer;
// //   transition:all .18s; background:#fff;
// // }
// // .fhd-cat-card:hover { border-color:#064e3b; background:#ecfdf5; transform:translateX(3px); }
// // .fhd-cat-card.active {
// //   border-color:#064e3b; background:#ecfdf5;
// //   box-shadow:0 0 0 3px rgba(6,78,59,.15);
// // }

// // .fhd-cat-avatar {
// //   width:38px; height:38px; flex-shrink:0;
// //   background:#064e3b;
// //   border-radius:10px; display:flex; align-items:center;
// //   justify-content:center; font-size:15px; color:#fff; font-weight:800;
// // }

// // .fhd-cat-info { flex:1; min-width:0; }
// // .fhd-cat-name  { font-size:13px; font-weight:700; color:#1e293b; }
// // .fhd-cat-sub   { font-size:11px; color:#64748b; font-weight:500; margin-top:2px; }

// // /* Badge - same as as-badge */
// // .fhd-badge {
// //   font-size:10px; font-weight:800; padding:3px 9px;
// //   border-radius:20px; flex-shrink:0; white-space:nowrap;
// // }
// // .fhd-badge.set   { background:#d1fae5; color:#064e3b; }
// // .fhd-badge.empty { background:#f1f5f9; color:#94a3b8; }

// // /* ══════════════════════════════
// //    RIGHT PANEL
// // ══════════════════════════════ */
// // .fhd-right {
// //   background:#fff;
// //   border:1.5px solid #e0e7ef;
// //   border-radius:14px;
// //   overflow:hidden;
// //   box-shadow:0 2px 12px rgba(30,58,95,.06);
// // }

// // /* Empty state - same as as-empty-state */
// // .fhd-empty-state {
// //   display:flex; flex-direction:column; align-items:center;
// //   justify-content:center; padding:80px 20px;
// //   color:#94a3b8; text-align:center;
// // }
// // .fhd-empty-icon  { font-size:52px; margin-bottom:16px; opacity:.35; }
// // .fhd-empty-title { font-size:15px; font-weight:700; color:#64748b; margin-bottom:6px; }
// // .fhd-empty-sub   { font-size:12.5px; }

// // /* Right header */
// // .fhd-right-header {
// //   background:#064e3b;
// //   padding:15px 20px;
// // }
// // .fhd-right-header-title { color:#fff; font-size:15px; font-weight:800; }
// // .fhd-right-header-sub   { color:rgba(255,255,255,.75); font-size:11.5px; margin-top:3px; }

// // /* Form Section */
// // .fhd-form-section {
// //   padding:16px 20px;
// //   border-bottom:1.5px solid #f0f4f8;
// //   background:#f0fdf4;
// // }
// // .fhd-form-label-row {
// //   display:flex; align-items:center; justify-content:space-between;
// //   margin-bottom:10px;
// // }
// // .fhd-form-section-label {
// //   font-size:11.5px; font-weight:800; color:#374151;
// //   text-transform:uppercase; letter-spacing:.6px;
// //   display:flex; align-items:center; gap:6px;
// // }
// // .fhd-edit-pill {
// //   background:#fef3c7; color:#92400e; border:1.5px solid #fcd34d;
// //   border-radius:20px; padding:3px 10px; font-size:11px; font-weight:700;
// //   display:flex; align-items:center; gap:5px;
// // }
// // .fhd-edit-pill button {
// //   background:none; border:none; color:#92400e;
// //   cursor:pointer; font-size:14px; line-height:1; padding:0; margin-left:2px;
// // }

// // .fhd-form-row { display:flex; gap:10px; align-items:flex-end; flex-wrap:wrap; }
// // .fhd-field { display:flex; flex-direction:column; gap:5px; flex:1; min-width:120px; }
// // .fhd-field label { font-size:11px; font-weight:700; color:#64748b; text-transform:uppercase; letter-spacing:.4px; }

// // .fhd-select, .fhd-input {
// //   padding:9px 12px; border:1.5px solid #e0e7ef; border-radius:9px;
// //   font-size:13px; color:#1e293b; background:#fff;
// //   font-family:'DM Sans',sans-serif; outline:none; transition:.2s;
// // }
// // .fhd-select:focus, .fhd-input:focus {
// //   border-color:#064e3b; box-shadow:0 0 0 3px rgba(6,78,59,.12);
// // }
// // .fhd-select.err, .fhd-input.err { border-color:#ef4444; box-shadow:0 0 0 3px rgba(239,68,68,.1); }
// // .fhd-select.ok,  .fhd-input.ok  { border-color:#10b981; }

// // /* Save button - same as as-save-btn */
// // .fhd-save-btn {
// //   background:linear-gradient(135deg,#064e3b,#047857);
// //   color:#fff; border:none; border-radius:9px;
// //   padding:9px 20px; font-size:13px; font-weight:700;
// //   cursor:pointer; font-family:'DM Sans',sans-serif;
// //   white-space:nowrap; display:flex; align-items:center; gap:6px;
// //   transition:opacity .2s,transform .2s; flex-shrink:0;
// // }
// // .fhd-save-btn:hover:not(:disabled) { opacity:.9; transform:translateY(-1px); }
// // .fhd-save-btn:disabled { opacity:.5; cursor:not-allowed; }

// // .fhd-cancel-btn {
// //   background:#f1f5f9; color:#64748b; border:none; border-radius:9px;
// //   padding:9px 16px; font-size:13px; font-weight:700;
// //   cursor:pointer; font-family:'DM Sans',sans-serif;
// //   transition:.15s; flex-shrink:0;
// // }
// // .fhd-cancel-btn:hover { background:#e2e8f0; }

// // /* Fee Head List - same as as-subjects-section */
// // .fhd-list-section { padding:16px 20px; }
// // .fhd-list-top {
// //   display:flex; align-items:center; justify-content:space-between;
// //   margin-bottom:12px;
// // }
// // .fhd-list-label {
// //   font-size:11px; font-weight:800; color:#94a3b8;
// //   text-transform:uppercase; letter-spacing:.7px;
// // }
// // .fhd-search-mini {
// //   padding:6px 10px; border:1.5px solid #e0e7ef; border-radius:8px;
// //   font-size:12px; font-family:'DM Sans',sans-serif; outline:none; width:150px;
// //   transition:.2s;
// // }
// // .fhd-search-mini:focus { border-color:#064e3b; box-shadow:0 0 0 3px rgba(6,78,59,.1); }

// // /* Fee Head Row - same as as-subject-row */
// // .fhd-head-row {
// //   display:flex; align-items:center; gap:10px;
// //   padding:10px 12px; border:1.5px solid #f0f4f8;
// //   border-radius:10px; margin-bottom:6px; background:#fff;
// //   transition:border-color .15s;
// // }
// // .fhd-head-row:hover { border-color:#a7f3d0; background:#f0fdf4; }
// // .fhd-head-row.editing { border-color:#fcd34d; background:#fffbeb; }

// // .fhd-head-num {
// //   width:26px; height:26px; border-radius:7px;
// //   background:#d1fae5; color:#064e3b;
// //   font-size:11px; font-weight:800;
// //   display:flex; align-items:center; justify-content:center; flex-shrink:0;
// // }

// // .fhd-head-info { flex:1; min-width:0; }
// // .fhd-head-name { font-size:13px; font-weight:700; color:#1e293b; }
// // .fhd-head-meta { font-size:11px; color:#64748b; margin-top:2px; }

// // .fhd-head-amount {
// //   font-size:13px; font-weight:800; color:#064e3b;
// //   background:#d1fae5; padding:4px 10px; border-radius:7px; flex-shrink:0;
// // }

// // .fhd-status-badge {
// //   font-size:10.5px; font-weight:700; padding:3px 9px;
// //   border-radius:20px; flex-shrink:0;
// // }
// // .fhd-status-badge.on  { background:#dcfce7; color:#15803d; }
// // .fhd-status-badge.off { background:#fee2e2; color:#991b1b; }

// // .fhd-row-actions { display:flex; gap:5px; flex-shrink:0; }
// // .fhd-action-btn {
// //   width:28px; height:28px; border:none; border-radius:7px;
// //   cursor:pointer; display:flex; align-items:center; justify-content:center;
// //   font-size:12px; transition:all .15s;
// // }
// // .fhd-action-btn:hover { transform:scale(1.1); }
// // .fhd-btn-edit        { background:#d1fae5; color:#064e3b; }
// // .fhd-btn-toggle-on   { background:#dcfce7; color:#15803d; }
// // .fhd-btn-toggle-off  { background:#fee2e2; color:#991b1b; }

// // .fhd-loading { text-align:center; padding:40px; color:#94a3b8; font-size:13px; }
// // .fhd-no-heads {
// //   text-align:center; padding:30px; color:#94a3b8;
// //   font-size:13px; background:#f9fafb;
// //   border-radius:10px; border:1.5px dashed #e2e8f0;
// // }

// // /* Skeleton */
// // .fhd-skeleton {
// //   border-radius:6px; height:13px;
// //   background:linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 50%,#f1f5f9 75%);
// //   background-size:200% 100%;
// //   animation:shimmer 1.5s infinite;
// // }
// // @keyframes shimmer{ 0%{background-position:200% 0}100%{background-position:-200% 0} }
// // `;

// // function FeeHeadDetails() {
// //   const { user } = useAuth();
// //   const { academicSession } = useContext(AcademicSessionContext);
// //   const campus_id = user?.user?.campus_id;

// //   // ── Data states ───────────────────────────────────
// //   const [getCategories, setCategories]  = useState([]);
// //   const [getFeeHeads,   setFeeHeads]    = useState([]);
// //   const [getFeeGroups,  setFeeGroups]   = useState([]);
// //   const [assignedMap,   setAssignedMap] = useState({}); // {category_id: count}

// //   // ── Panel states (same as AssignSubjects) ─────────
// //   const [selectedCategory, setSelectedCategory] = useState(null);
// //   const [cardFeeHeads,     setCardFeeHeads]      = useState([]);
// //   const [loadingCard,      setLoadingCard]        = useState(false);
// //   const [saving,           setSaving]             = useState(false);

// //   // ── Search ────────────────────────────────────────
// //   const [catSearch,  setCatSearch]  = useState('');
// //   const [listSearch, setListSearch] = useState('');

// //   // ── Form ──────────────────────────────────────────
// //   const emptyForm = { fee_head_id:'', fee_group_id:'', shift:'', amount:'', hidden_id:'' };
// //   const [form,     setForm]     = useState(emptyForm);
// //   const [validity, setValidity] = useState({ fee_head_id:true, fee_group_id:true, shift:true, amount:true });
// //   const isEditing = form.hidden_id !== '';

// //   // ── Fetch categories ──────────────────────────────
// //   useEffect(() => {
// //     if (!campus_id) return;
// //     axios.get(`${process.env.REACT_APP_API_BASE_URL}/get-categories/${campus_id}`)
// //       .then(res => setCategories(res.data.results))
// //       .catch(console.error);
// //   }, [campus_id]);

// //   // ── Fetch fee head dropdown options ───────────────
// //   useEffect(() => {
// //     if (!campus_id) return;
// //     axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-heads/${campus_id}`)
// //       .then(res => setFeeHeads(res.data.results))
// //       .catch(console.error);
// //   }, [campus_id]);

// //   // ── Fetch fee groups dropdown ─────────────────────
// //   useEffect(() => {
// //     if (!campus_id) return;
// //     axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-groups/${campus_id}`)
// //       .then(res => setFeeGroups(res.data.results))
// //       .catch(console.error);
// //   }, [campus_id]);

// //   // ── Build assignedMap (same concept as AssignSubjects)
// //   //    Tells left panel which categories have records ─
// //   useEffect(() => {
// //     if (!campus_id) return;
// //     axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-head-details-list`, {
// //       params: { page:1, limit:500, campus_id }
// //     }).then(res => {
// //       const map = {};
// //       res.data.results.forEach(item => {
// //         map[item.category_id] = (map[item.category_id] || 0) + 1;
// //       });
// //       setAssignedMap(map);
// //     }).catch(console.error);
// //   }, [campus_id]);

// //   // ── Click category card (same as handleCardClick) ─
// //   const handleCategoryClick = (cat) => {
// //     setSelectedCategory({ category_id: cat.id, label: cat.category });
// //     setForm(emptyForm);
// //     setLoadingCard(true);

// //     axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-head-details-list`, {
// //       params: { page:1, limit:200, campus_id, category_id: cat.id }
// //     }).then(res => {
// //       setCardFeeHeads(res.data.results);
// //       setLoadingCard(false);
// //     }).catch(err => { console.error(err); setLoadingCard(false); });
// //   };

// //   // ── Validate ──────────────────────────────────────
// //   const validate = () => {
// //     const v = {
// //       fee_head_id:  !!form.fee_head_id,
// //       fee_group_id: !!form.fee_group_id,
// //       shift:        !!form.shift,
// //       amount:       !!form.amount && String(form.amount).trim() !== '',
// //     };
// //     setValidity(v);
// //     return Object.values(v).every(Boolean);
// //   };

// //   // ── Save / Update (same flow as handleSave) ───────
// //   const handleSave = async () => {
// //     if (!selectedCategory) return;
// //     if (!validate()) { toast.warning('Please fill all fields'); return; }
// //     setSaving(true);
// //     try {
// //       await axios.post(
// //         `${process.env.REACT_APP_API_BASE_URL}/insert-fee-head-details`,
// //         {
// //           fee_head_id:  form.fee_head_id,
// //           category_id:  selectedCategory.category_id,
// //           fee_group_id: form.fee_group_id,
// //           shift:        form.shift,
// //           amount:       form.amount,
// //           session_id:   parseInt(academicSession),
// //           campus_id,
// //           user_id:      user?.user?.user_id,
// //           hidden_id:    form.hidden_id,
// //         },
// //         { headers: { 'Content-Type': 'application/json' } }
// //       );

// //       toast.success(isEditing ? '✅ Record updated!' : '✅ Fee head added!');
// //       setForm(emptyForm);

// //       // Re-fetch this card's data (same as AssignSubjects re-fetch after save)
// //       const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-head-details-list`, {
// //         params: { page:1, limit:200, campus_id, category_id: selectedCategory.category_id }
// //       });
// //       setCardFeeHeads(res.data.results);

// //       // Update left badge count (same as setAssignedMap after save)
// //       setAssignedMap(prev => ({
// //         ...prev,
// //         [selectedCategory.category_id]: res.data.results.length
// //       }));

// //     } catch (error) {
// //       toast.error(error.response?.data?.error || 'Something went wrong');
// //     }
// //     setSaving(false);
// //   };

// //   // ── Edit — fills form inline ───────────────────────
// //   const handleEdit = (item) => {
// //     setForm({
// //       fee_head_id:  item.fee_head_id  || '',
// //       fee_group_id: item.fee_group_id || '',
// //       shift:        item.shift        || '',
// //       amount:       item.amount       || '',
// //       hidden_id:    item.id           || '',
// //     });
// //     toast.info('✏️ Edit mode — update the form above');
// //   };

// //   // ── Toggle status (optimistic update — same as delete in AssignSubjects)
// //   const handleToggle = (id, currentStatus) => {
// //     // Optimistic update first
// //     setCardFeeHeads(prev =>
// //       prev.map(item =>
// //         item.id === id
// //           ? { ...item, status: currentStatus === 'On' ? 'Off' : 'On' }
// //           : item
// //       )
// //     );
// //     axios.delete(`${process.env.REACT_APP_API_BASE_URL}/soft-delete-fee-head-details/${id}/${currentStatus}`)
// //       .catch(err => {
// //         // Rollback on failure
// //         setCardFeeHeads(prev =>
// //           prev.map(item => item.id === id ? { ...item, status: currentStatus } : item)
// //         );
// //         console.error(err);
// //       });
// //   };

// //   // ── Filtered lists ────────────────────────────────
// //   const filteredCats = getCategories.filter(c =>
// //     c.category?.toLowerCase().includes(catSearch.toLowerCase())
// //   );
// //   const filteredHeads = cardFeeHeads.filter(h =>
// //     h.head_name?.toLowerCase().includes(listSearch.toLowerCase()) ||
// //     h.shift?.toLowerCase().includes(listSearch.toLowerCase())
// //   );

// //   // Field class helper
// //   const fc = (field) => {
// //     if (!validity[field]) return 'err';
// //     if (form[field])      return 'ok';
// //     return '';
// //   };

// //   return (
// //     <>
// //       <style>{CSS}</style>
// //       <div className="fhd-root">
// //         <div className="fhd-layout">

// //           {/* ══════════════════════════════════════
// //               LEFT PANEL — Category Cards
// //               (same structure as Class Cards)
// //           ══════════════════════════════════════ */}
// //           <div className="fhd-left">
// //             <div className="fhd-left-header">
// //               <h6>📂 Categories</h6>
// //               <p>Click a category to manage its fee heads</p>
// //             </div>

// //             <div className="fhd-cat-search">
// //               <input
// //                 type="text"
// //                 placeholder="🔍 Search category..."
// //                 value={catSearch}
// //                 onChange={e => setCatSearch(e.target.value)}
// //               />
// //             </div>

// //             <div className="fhd-cat-list">
// //               {filteredCats.length === 0 ? (
// //                 <div style={{textAlign:'center',padding:20,color:'#94a3b8',fontSize:13}}>
// //                   No categories found
// //                 </div>
// //               ) : filteredCats.map((cat, i) => {
// //                 const isActive = selectedCategory?.category_id === cat.id;
// //                 const count    = assignedMap[cat.id] || 0;
// //                 return (
// //                   <div
// //                     key={i}
// //                     className={`fhd-cat-card ${isActive ? 'active' : ''}`}
// //                     onClick={() => handleCategoryClick(cat)}
// //                   >
// //                     {/* Avatar with first letter — same as as-class-avatar */}
// //                     <div className="fhd-cat-avatar">
// //                       {cat.category?.charAt(0).toUpperCase()}
// //                     </div>

// //                     <div className="fhd-cat-info">
// //                       <div className="fhd-cat-name">{cat.category}</div>
// //                       <div className="fhd-cat-sub">
// //                         {count > 0 ? `${count} fee head${count > 1 ? 's' : ''} configured` : 'No fee heads yet'}
// //                       </div>
// //                     </div>

// //                     {/* Badge — same as ✓ Set / Empty */}
// //                     <span className={`fhd-badge ${count > 0 ? 'set' : 'empty'}`}>
// //                       {count > 0 ? `✓ ${count}` : 'Empty'}
// //                     </span>
// //                   </div>
// //                 );
// //               })}
// //             </div>
// //           </div>

// //           {/* ══════════════════════════════════════
// //               RIGHT PANEL — Manage Fee Heads
// //               (same structure as Manage Subjects)
// //           ══════════════════════════════════════ */}
// //           <div className="fhd-right">

// //             {/* Phase 1 — Nothing selected (same as AssignSubjects empty state) */}
// //             {!selectedCategory ? (
// //               <div className="fhd-empty-state">
// //                 <div className="fhd-empty-icon">👈</div>
// //                 <div className="fhd-empty-title">Select a category first</div>
// //                 <div className="fhd-empty-sub">
// //                   Click any category from the left panel<br/>
// //                   to assign or manage its fee heads
// //                 </div>
// //               </div>
// //             ) : (
// //               <>
// //                 {/* Right Header */}
// //                 <div className="fhd-right-header">
// //                   <div className="fhd-right-header-title">🏷️ {selectedCategory.label}</div>
// //                   <div className="fhd-right-header-sub">
// //                     {loadingCard
// //                       ? 'Loading...'
// //                       : `${cardFeeHeads.length} fee head${cardFeeHeads.length !== 1 ? 's' : ''} configured`
// //                     }
// //                   </div>
// //                 </div>

// //                 {/* ── Add / Edit Form
// //                     Same as "Add New Subjects" section ── */}
// //                 <div className="fhd-form-section">
// //                   <div className="fhd-form-label-row">
// //                     <div className="fhd-form-section-label">
// //                       {isEditing ? '✏️ Edit Fee Head' : '➕ Add New Fee Head'}
// //                     </div>
// //                     {isEditing && (
// //                       <div className="fhd-edit-pill">
// //                         Editing record
// //                         <button onClick={() => setForm(emptyForm)}>×</button>
// //                       </div>
// //                     )}
// //                   </div>

// //                   <div className="fhd-form-row">
// //                     {/* Shift */}
// //                     <div className="fhd-field">
// //                       <label>Shift *</label>
// //                       <select
// //                         className={`fhd-select ${fc('shift')}`}
// //                         value={form.shift}
// //                         onChange={e => {
// //                           setForm(f => ({...f, shift: e.target.value}));
// //                           setValidity(v => ({...v, shift: true}));
// //                         }}
// //                       >
// //                         <option value="">— Select —</option>
// //                         <option>Morning</option>
// //                         <option>Evening</option>
// //                       </select>
// //                     </div>

// //                     {/* Fee Group */}
// //                     <div className="fhd-field">
// //                       <label>Fee Group</label>
// //                       <select
// //                         className={`fhd-select ${fc('fee_group_id')}`}
// //                         value={form.fee_group_id}
// //                         onChange={e => {
// //                           setForm(f => ({...f, fee_group_id: e.target.value}));
// //                           setValidity(v => ({...v, fee_group_id: true}));
// //                         }}
// //                       >
// //                         <option value="">— Select Group —</option>
// //                         {getFeeGroups.map((g, i) => (
// //                           <option key={i} value={g.id}>{g.fee_group_name}</option>
// //                         ))}
// //                       </select>
// //                     </div>

// //                     {/* Fee Head */}
// //                     <div className="fhd-field">
// //                       <label>Fee Head *</label>
// //                       <select
// //                         className={`fhd-select ${fc('fee_head_id')}`}
// //                         value={form.fee_head_id}
// //                         onChange={e => {
// //                           setForm(f => ({...f, fee_head_id: e.target.value}));
// //                           setValidity(v => ({...v, fee_head_id: true}));
// //                         }}
// //                       >
// //                         <option value="">— Select Head —</option>
// //                         {getFeeHeads.map((h, i) => (
// //                           <option key={i} value={h.id}>{h.head_name}</option>
// //                         ))}
// //                       </select>
// //                     </div>

// //                     {/* Amount */}
// //                     <div className="fhd-field">
// //                       <label>Amount (PKR) *</label>
// //                       <input
// //                         type="number"
// //                         min="0"
// //                         placeholder="e.g. 5000"
// //                         className={`fhd-input ${fc('amount')}`}
// //                         value={form.amount}
// //                         onChange={e => {
// //                           setForm(f => ({...f, amount: e.target.value}));
// //                           setValidity(v => ({...v, amount: true}));
// //                         }}
// //                       />
// //                     </div>

// //                     {/* Buttons */}
// //                     <div style={{display:'flex', gap:8, alignItems:'flex-end', flexShrink:0}}>
// //                       {isEditing && (
// //                         <button className="fhd-cancel-btn" onClick={() => setForm(emptyForm)}>
// //                           Cancel
// //                         </button>
// //                       )}
// //                       <button
// //                         className="fhd-save-btn"
// //                         onClick={handleSave}
// //                         disabled={saving}
// //                       >
// //                         <i className={`fas fa-${saving ? 'spinner fa-spin' : isEditing ? 'save' : 'plus-circle'}`} />
// //                         {saving ? 'Saving...' : isEditing ? 'Update' : 'Add'}
// //                       </button>
// //                     </div>
// //                   </div>
// //                 </div>

// //                 {/* ── Fee Heads List
// //                     Same as "Currently Assigned Subjects" section ── */}
// //                 <div className="fhd-list-section">
// //                   <div className="fhd-list-top">
// //                     <div className="fhd-list-label">Assigned Fee Heads</div>
// //                     {cardFeeHeads.length > 0 && (
// //                       <input
// //                         type="text"
// //                         className="fhd-search-mini"
// //                         placeholder="🔍 Filter..."
// //                         value={listSearch}
// //                         onChange={e => setListSearch(e.target.value)}
// //                       />
// //                     )}
// //                   </div>

// //                   {/* Phase 2 — Loading skeleton */}
// //                   {loadingCard ? (
// //                     Array(3).fill(0).map((_, i) => (
// //                       <div key={i} className="fhd-head-row" style={{gap:12}}>
// //                         <div className="fhd-skeleton" style={{width:26,height:26,borderRadius:7,flexShrink:0}}/>
// //                         <div style={{flex:1}}>
// //                           <div className="fhd-skeleton" style={{width:'60%',marginBottom:6}}/>
// //                           <div className="fhd-skeleton" style={{width:'35%',height:10}}/>
// //                         </div>
// //                         <div className="fhd-skeleton" style={{width:70,height:26,borderRadius:7}}/>
// //                       </div>
// //                     ))

// //                   /* Phase 3a — Empty */
// //                   ) : cardFeeHeads.length === 0 ? (
// //                     <div className="fhd-no-heads">
// //                       No fee heads assigned yet.<br/>
// //                       Use the form above to add fee heads for <strong>{selectedCategory.label}</strong>.
// //                     </div>

// //                   /* Phase 3b — Content (same row as as-subject-row) */
// //                   ) : filteredHeads.map((item, index) => (
// //                     <div
// //                       key={index}
// //                       className={`fhd-head-row ${form.hidden_id === item.id ? 'editing' : ''}`}
// //                     >
// //                       {/* Number — same as as-subject-num */}
// //                       <div className="fhd-head-num">{index + 1}</div>

// //                       {/* Info */}
// //                       <div className="fhd-head-info">
// //                         <div className="fhd-head-name">{item.head_name}</div>
// //                         <div className="fhd-head-meta">
// //                           <i className="fas fa-clock" style={{marginRight:4,fontSize:10}}/>
// //                           {item.shift}
// //                         </div>
// //                       </div>

// //                       {/* Amount pill */}
// //                       <div className="fhd-head-amount">
// //                         Rs. {Number(item.amount).toLocaleString()}
// //                       </div>

// //                       {/* Status badge */}
// //                       <span className={`fhd-status-badge ${item.status === 'On' ? 'on' : 'off'}`}>
// //                         {item.status === 'On' ? '● Active' : '● Inactive'}
// //                       </span>

// //                       {/* Actions — same as delete button in AssignSubjects */}
// //                       <div className="fhd-row-actions">
// //                         <button
// //                           className="fhd-action-btn fhd-btn-edit"
// //                           onClick={() => handleEdit(item)}
// //                           title="Edit this record"
// //                         >
// //                           <i className="fas fa-pen"/>
// //                         </button>
// //                         <button
// //                           className={`fhd-action-btn ${item.status === 'On' ? 'fhd-btn-toggle-on' : 'fhd-btn-toggle-off'}`}
// //                           onClick={() => handleToggle(item.id, item.status)}
// //                           title={item.status === 'On' ? 'Deactivate' : 'Activate'}
// //                         >
// //                           <i className={`fas fa-toggle-${item.status === 'On' ? 'on' : 'off'}`}/>
// //                         </button>
// //                       </div>
// //                     </div>
// //                   ))}
// //                 </div>
// //               </>
// //             )}
// //           </div>

// //         </div>
// //       </div>
// //     </>
// //   );
// // }

// // export default FeeHeadDetails;






// import React, { useEffect, useState, useContext } from 'react';
// import axios from 'axios';
// import { useAuth } from './AuthContext';
// import AcademicSessionContext from './AcademicSessionContext';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// /* ─────────────────────────────────────────────────────────────
//    EXACT SAME PATTERN AS AssignSubjects
//    Left  = Category cards  (like Class cards)
//    Right = Fee heads list + inline form  (like Subjects panel)
// ───────────────────────────────────────────────────────────── */

// const CSS = `
// @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');

// .fhd-root { font-family:'DM Sans',sans-serif; padding:16px; background:#f0fdf4; min-height:100vh; }

// /* ── Layout ── */
// .fhd-layout {
//   display:grid;
//   grid-template-columns:300px 1fr;
//   gap:20px;
//   align-items:start;
// }
// @media(max-width:860px){ .fhd-layout{ grid-template-columns:1fr; } }

// /* ══════════════════════════════
//    LEFT PANEL  (Category Cards)
// ══════════════════════════════ */
// .fhd-left {
//   background:#fff;
//   border:1.5px solid #e0e7ef;
//   border-radius:14px;
//   overflow:hidden;
//   box-shadow:0 2px 12px rgba(30,58,95,.06);
// }
// .fhd-left-header {
//   background:#064e3b;
//   padding:16px 18px; color:#fff;
// }
// .fhd-left-header h6 { margin:0; font-size:14px; font-weight:800; }
// .fhd-left-header p  { margin:4px 0 0; font-size:11.5px; opacity:.8; }

// .fhd-cat-search { padding:10px 12px; border-bottom:1px solid #f0f4f8; }
// .fhd-cat-search input {
//   width:100%; border:1.5px solid #e0e7ef; border-radius:8px;
//   padding:7px 12px; font-size:13px; font-family:'DM Sans',sans-serif;
//   outline:none; transition:.2s;
// }
// .fhd-cat-search input:focus { border-color:#064e3b; box-shadow:0 0 0 3px rgba(6,78,59,.12); }

// .fhd-cat-list {
//   max-height:520px; overflow-y:auto; padding:8px;
//   display:flex; flex-direction:column; gap:6px;
//   scrollbar-width:thin; scrollbar-color:#6ee7b7 transparent;
// }

// /* Category Card - same as as-class-card */
// .fhd-cat-card {
//   display:flex; align-items:center; gap:10px;
//   padding:10px 12px; border:1.5px solid #f0f4f8;
//   border-radius:10px; cursor:pointer;
//   transition:all .18s; background:#fff;
// }
// .fhd-cat-card:hover { border-color:#064e3b; background:#ecfdf5; transform:translateX(3px); }
// .fhd-cat-card.active {
//   border-color:#064e3b; background:#ecfdf5;
//   box-shadow:0 0 0 3px rgba(6,78,59,.15);
// }

// .fhd-cat-avatar {
//   width:38px; height:38px; flex-shrink:0;
//   background:#064e3b;
//   border-radius:10px; display:flex; align-items:center;
//   justify-content:center; font-size:15px; color:#fff; font-weight:800;
// }

// .fhd-cat-info { flex:1; min-width:0; }
// .fhd-cat-name  { font-size:13px; font-weight:700; color:#1e293b; }
// .fhd-cat-sub   { font-size:11px; color:#64748b; font-weight:500; margin-top:2px; }

// /* Badge - same as as-badge */
// .fhd-badge {
//   font-size:10px; font-weight:800; padding:3px 9px;
//   border-radius:20px; flex-shrink:0; white-space:nowrap;
// }
// .fhd-badge.set   { background:#d1fae5; color:#064e3b; }
// .fhd-badge.empty { background:#f1f5f9; color:#94a3b8; }

// /* ══════════════════════════════
//    RIGHT PANEL
// ══════════════════════════════ */
// .fhd-right {
//   background:#fff;
//   border:1.5px solid #e0e7ef;
//   border-radius:14px;
//   overflow:hidden;
//   box-shadow:0 2px 12px rgba(30,58,95,.06);
// }

// /* Empty state - same as as-empty-state */
// .fhd-empty-state {
//   display:flex; flex-direction:column; align-items:center;
//   justify-content:center; padding:80px 20px;
//   color:#94a3b8; text-align:center;
// }
// .fhd-empty-icon  { font-size:52px; margin-bottom:16px; opacity:.35; }
// .fhd-empty-title { font-size:15px; font-weight:700; color:#64748b; margin-bottom:6px; }
// .fhd-empty-sub   { font-size:12.5px; }

// /* Right header */
// .fhd-right-header {
//   background:#064e3b;
//   padding:15px 20px;
// }
// .fhd-right-header-title { color:#fff; font-size:15px; font-weight:800; }
// .fhd-right-header-sub   { color:rgba(255,255,255,.75); font-size:11.5px; margin-top:3px; }

// /* Form Section */
// .fhd-form-section {
//   padding:16px 20px;
//   border-bottom:1.5px solid #f0f4f8;
//   background:#f0fdf4;
// }
// .fhd-form-label-row {
//   display:flex; align-items:center; justify-content:space-between;
//   margin-bottom:10px;
// }
// .fhd-form-section-label {
//   font-size:11.5px; font-weight:800; color:#374151;
//   text-transform:uppercase; letter-spacing:.6px;
//   display:flex; align-items:center; gap:6px;
// }
// .fhd-edit-pill {
//   background:#fef3c7; color:#92400e; border:1.5px solid #fcd34d;
//   border-radius:20px; padding:3px 10px; font-size:11px; font-weight:700;
//   display:flex; align-items:center; gap:5px;
// }
// .fhd-edit-pill button {
//   background:none; border:none; color:#92400e;
//   cursor:pointer; font-size:14px; line-height:1; padding:0; margin-left:2px;
// }

// .fhd-form-grid {
//   display:grid;
//   grid-template-columns:1fr 1fr;
//   gap:12px;
// }
// @media(max-width:600px){ .fhd-form-grid{ grid-template-columns:1fr; } }

// .fhd-form-row2 {
//   display:grid;
//   grid-template-columns:1fr 1fr auto;
//   gap:12px;
//   align-items:flex-end;
//   margin-top:12px;
// }
// @media(max-width:600px){ .fhd-form-row2{ grid-template-columns:1fr; } }

// .fhd-field { display:flex; flex-direction:column; gap:5px; }
// .fhd-field label {
//   font-size:11px; font-weight:700; color:#374151;
//   text-transform:uppercase; letter-spacing:.4px;
//   display:flex; align-items:center; gap:5px;
// }
// .fhd-field label .req { color:#ef4444; }
// .fhd-field label .lbl-icon {
//   width:18px; height:18px; border-radius:5px;
//   background:#064e3b; color:#fff;
//   font-size:9px; display:inline-flex;
//   align-items:center; justify-content:center;
// }

// .fhd-select, .fhd-input {
//   padding:9px 12px; border:1.5px solid #e0e7ef; border-radius:9px;
//   font-size:13px; color:#1e293b; background:#fff;
//   font-family:'DM Sans',sans-serif; outline:none; transition:.2s;
// }
// .fhd-select:focus, .fhd-input:focus {
//   border-color:#064e3b; box-shadow:0 0 0 3px rgba(6,78,59,.12);
// }
// .fhd-select.err, .fhd-input.err { border-color:#ef4444; box-shadow:0 0 0 3px rgba(239,68,68,.1); }
// .fhd-select.ok,  .fhd-input.ok  { border-color:#10b981; }

// /* Save button - same as as-save-btn */
// .fhd-save-btn {
//   background:linear-gradient(135deg,#064e3b,#047857);
//   color:#fff; border:none; border-radius:9px;
//   padding:9px 20px; font-size:13px; font-weight:700;
//   cursor:pointer; font-family:'DM Sans',sans-serif;
//   white-space:nowrap; display:flex; align-items:center; gap:6px;
//   transition:opacity .2s,transform .2s; flex-shrink:0;
// }
// .fhd-save-btn:hover:not(:disabled) { opacity:.9; transform:translateY(-1px); }
// .fhd-save-btn:disabled { opacity:.5; cursor:not-allowed; }

// .fhd-cancel-btn {
//   background:#f1f5f9; color:#64748b; border:none; border-radius:9px;
//   padding:9px 16px; font-size:13px; font-weight:700;
//   cursor:pointer; font-family:'DM Sans',sans-serif;
//   transition:.15s; flex-shrink:0;
// }
// .fhd-cancel-btn:hover { background:#e2e8f0; }

// /* Fee Head List - same as as-subjects-section */
// .fhd-list-section { padding:16px 20px; }
// .fhd-list-top {
//   display:flex; align-items:center; justify-content:space-between;
//   margin-bottom:12px;
// }
// .fhd-list-label {
//   font-size:11px; font-weight:800; color:#94a3b8;
//   text-transform:uppercase; letter-spacing:.7px;
// }
// .fhd-search-mini {
//   padding:6px 10px; border:1.5px solid #e0e7ef; border-radius:8px;
//   font-size:12px; font-family:'DM Sans',sans-serif; outline:none; width:150px;
//   transition:.2s;
// }
// .fhd-search-mini:focus { border-color:#064e3b; box-shadow:0 0 0 3px rgba(6,78,59,.1); }

// /* Fee Head Row - same as as-subject-row */
// .fhd-head-row {
//   display:flex; align-items:center; gap:10px;
//   padding:10px 12px; border:1.5px solid #f0f4f8;
//   border-radius:10px; margin-bottom:6px; background:#fff;
//   transition:border-color .15s;
// }
// .fhd-head-row:hover { border-color:#a7f3d0; background:#f0fdf4; }
// .fhd-head-row.editing { border-color:#fcd34d; background:#fffbeb; }

// .fhd-head-num {
//   width:26px; height:26px; border-radius:7px;
//   background:#d1fae5; color:#064e3b;
//   font-size:11px; font-weight:800;
//   display:flex; align-items:center; justify-content:center; flex-shrink:0;
// }

// .fhd-head-info { flex:1; min-width:0; }
// .fhd-head-name { font-size:13px; font-weight:700; color:#1e293b; }
// .fhd-head-meta { font-size:11px; color:#64748b; margin-top:2px; }

// .fhd-head-amount {
//   font-size:13px; font-weight:800; color:#064e3b;
//   background:#d1fae5; padding:4px 10px; border-radius:7px; flex-shrink:0;
// }

// .fhd-status-badge {
//   font-size:10.5px; font-weight:700; padding:3px 9px;
//   border-radius:20px; flex-shrink:0;
// }
// .fhd-status-badge.on  { background:#dcfce7; color:#15803d; }
// .fhd-status-badge.off { background:#fee2e2; color:#991b1b; }

// .fhd-row-actions { display:flex; gap:5px; flex-shrink:0; }
// .fhd-action-btn {
//   width:28px; height:28px; border:none; border-radius:7px;
//   cursor:pointer; display:flex; align-items:center; justify-content:center;
//   font-size:12px; transition:all .15s;
// }
// .fhd-action-btn:hover { transform:scale(1.1); }
// .fhd-btn-edit        { background:#d1fae5; color:#064e3b; }
// .fhd-btn-toggle-on   { background:#dcfce7; color:#15803d; }
// .fhd-btn-toggle-off  { background:#fee2e2; color:#991b1b; }

// .fhd-loading { text-align:center; padding:40px; color:#94a3b8; font-size:13px; }
// .fhd-no-heads {
//   text-align:center; padding:30px; color:#94a3b8;
//   font-size:13px; background:#f9fafb;
//   border-radius:10px; border:1.5px dashed #e2e8f0;
// }

// /* Group tag in list row */
// .fhd-group-tag {
//   display:inline-flex; align-items:center; gap:4px;
//   background:#ecfdf5; color:#064e3b; border:1px solid #a7f3d0;
//   border-radius:6px; padding:2px 7px;
//   font-size:10.5px; font-weight:700; flex-shrink:0;
// }
// /* Divider inside form */
// .fhd-form-divider {
//   border:none; border-top:1.5px dashed #d1fae5; margin:14px 0 4px;
// }
// /* Form step labels */
// .fhd-step-label {
//   font-size:10.5px; font-weight:800; color:#064e3b;
//   text-transform:uppercase; letter-spacing:.6px;
//   display:flex; align-items:center; gap:6px; margin-bottom:8px;
// }
// .fhd-step-label .step-circle {
//   width:18px; height:18px; border-radius:50%;
//   background:#064e3b; color:#fff;
//   font-size:10px; font-weight:800;
//   display:flex; align-items:center; justify-content:center;
// }
// /* Skeleton */
// .fhd-skeleton {
//   border-radius:6px; height:13px;
//   background:linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 50%,#f1f5f9 75%);
//   background-size:200% 100%;
//   animation:shimmer 1.5s infinite;
// }
// @keyframes shimmer{ 0%{background-position:200% 0}100%{background-position:-200% 0} }
// `;

// function FeeHeadDetails() {
//   const { user } = useAuth();
//   const { academicSession } = useContext(AcademicSessionContext);
//   const campus_id = user?.user?.campus_id;

//   // ── Data states ───────────────────────────────────
//   const [getCategories, setCategories]  = useState([]);
//   const [getFeeHeads,   setFeeHeads]    = useState([]);
//   const [getFeeGroups,  setFeeGroups]   = useState([]);
//   const [assignedMap,   setAssignedMap] = useState({}); // {category_id: count}

//   // ── Panel states (same as AssignSubjects) ─────────
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [cardFeeHeads,     setCardFeeHeads]      = useState([]);
//   const [loadingCard,      setLoadingCard]        = useState(false);
//   const [saving,           setSaving]             = useState(false);

//   // ── Search ────────────────────────────────────────
//   const [catSearch,  setCatSearch]  = useState('');
//   const [listSearch, setListSearch] = useState('');

//   // ── Form ──────────────────────────────────────────
//   const emptyForm = { fee_head_id:'', fee_group_id:'', shift:'', amount:'', hidden_id:'' };
//   const [form,     setForm]     = useState(emptyForm);
//   const [validity, setValidity] = useState({ fee_head_id:true, fee_group_id:true, shift:true, amount:true });
//   const isEditing = form.hidden_id !== '';

//   // ── Fetch categories ──────────────────────────────
//   useEffect(() => {
//     if (!campus_id) return;
//     axios.get(`${process.env.REACT_APP_API_BASE_URL}/get-categories/${campus_id}`)
//       .then(res => setCategories(res.data.results))
//       .catch(console.error);
//   }, [campus_id]);

//   // ── Fetch fee head dropdown options ───────────────
//   useEffect(() => {
//     if (!campus_id) return;
//     axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-heads/${campus_id}`)
//       .then(res => setFeeHeads(res.data.results))
//       .catch(console.error);
//   }, [campus_id]);

//   // ── Fetch fee groups dropdown ─────────────────────
//   useEffect(() => {
//     if (!campus_id) return;
//     axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-groups/${campus_id}`)
//       .then(res => setFeeGroups(res.data.results))
//       .catch(console.error);
//   }, [campus_id]);

//   // ── Build assignedMap (same concept as AssignSubjects)
//   //    Tells left panel which categories have records ─
//   useEffect(() => {
//     if (!campus_id) return;
//     axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-head-details-list`, {
//       params: { page:1, limit:500, campus_id }
//     }).then(res => {
//       const map = {};
//       res.data.results.forEach(item => {
//         map[item.category_id] = (map[item.category_id] || 0) + 1;
//       });
//       setAssignedMap(map);
//     }).catch(console.error);
//   }, [campus_id]);

//   // ── Click category card (same as handleCardClick) ─
//   const handleCategoryClick = (cat) => {
//     setSelectedCategory({ category_id: cat.id, label: cat.category });
//     setForm(emptyForm);
//     setLoadingCard(true);

//     axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-head-details-list`, {
//       params: { page:1, limit:200, campus_id, category_id: cat.id }
//     }).then(res => {
//       setCardFeeHeads(res.data.results);
//       setLoadingCard(false);
//     }).catch(err => { console.error(err); setLoadingCard(false); });
//   };

//   // ── Validate ──────────────────────────────────────
//   const validate = () => {
//     const v = {
//       fee_head_id:  !!form.fee_head_id,
//       fee_group_id: !!form.fee_group_id,
//       shift:        !!form.shift,
//       amount:       !!form.amount && String(form.amount).trim() !== '',
//     };
//     setValidity(v);
//     return Object.values(v).every(Boolean);
//   };

//   // ── Save / Update (same flow as handleSave) ───────
//   const handleSave = async () => {
//     if (!selectedCategory) return;
//     if (!validate()) { toast.warning('Please fill all fields'); return; }
//     setSaving(true);
//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/insert-fee-head-details`,
//         {
//           fee_head_id:  form.fee_head_id,
//           category_id:  selectedCategory.category_id,
//           fee_group_id: form.fee_group_id,
//           shift:        form.shift,
//           amount:       form.amount,
//           session_id:   parseInt(academicSession),
//           campus_id,
//           user_id:      user?.user?.user_id,
//           hidden_id:    form.hidden_id,
//         },
//         { headers: { 'Content-Type': 'application/json' } }
//       );

//       toast.success(isEditing ? '✅ Record updated!' : '✅ Fee head added!');
//       setForm(emptyForm);

//       // Re-fetch this card's data (same as AssignSubjects re-fetch after save)
//       const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-head-details-list`, {
//         params: { page:1, limit:200, campus_id, category_id: selectedCategory.category_id }
//       });
//       setCardFeeHeads(res.data.results);

//       // Update left badge count (same as setAssignedMap after save)
//       setAssignedMap(prev => ({
//         ...prev,
//         [selectedCategory.category_id]: res.data.results.length
//       }));

//     } catch (error) {
//       toast.error(error.response?.data?.error || 'Something went wrong');
//     }
//     setSaving(false);
//   };

//   // ── Edit — fills form inline ───────────────────────
//   const handleEdit = (item) => {
//     setForm({
//       fee_head_id:  item.fee_head_id  || '',
//       fee_group_id: item.fee_group_id || '',
//       shift:        item.shift        || '',
//       amount:       item.amount       || '',
//       hidden_id:    item.id           || '',
//     });
//     toast.info('✏️ Edit mode — update the form above');
//   };

//   // ── Toggle status (optimistic update — same as delete in AssignSubjects)
//   const handleToggle = (id, currentStatus) => {
//     // Optimistic update first
//     setCardFeeHeads(prev =>
//       prev.map(item =>
//         item.id === id
//           ? { ...item, status: currentStatus === 'On' ? 'Off' : 'On' }
//           : item
//       )
//     );
//     axios.delete(`${process.env.REACT_APP_API_BASE_URL}/soft-delete-fee-head-details/${id}/${currentStatus}`)
//       .catch(err => {
//         // Rollback on failure
//         setCardFeeHeads(prev =>
//           prev.map(item => item.id === id ? { ...item, status: currentStatus } : item)
//         );
//         console.error(err);
//       });
//   };

//   // ── Filtered lists ────────────────────────────────
//   const filteredCats = getCategories.filter(c =>
//     c.category?.toLowerCase().includes(catSearch.toLowerCase())
//   );
//   const filteredHeads = cardFeeHeads.filter(h =>
//     h.head_name?.toLowerCase().includes(listSearch.toLowerCase()) ||
//     h.shift?.toLowerCase().includes(listSearch.toLowerCase()) ||
//     h.fee_group_name?.toLowerCase().includes(listSearch.toLowerCase())
//   );

//   // Field class helper
//   const fc = (field) => {
//     if (!validity[field]) return 'err';
//     if (form[field])      return 'ok';
//     return '';
//   };

//   return (
//     <>
//       <style>{CSS}</style>
//       <div className="fhd-root">
//         <div className="fhd-layout">

//           {/* ══════════════════════════════════════
//               LEFT PANEL — Category Cards
//               (same structure as Class Cards)
//           ══════════════════════════════════════ */}
//           <div className="fhd-left">
//             <div className="fhd-left-header">
//               <h6>📂 Categories</h6>
//               <p>Click a category to manage its fee heads</p>
//             </div>

//             <div className="fhd-cat-search">
//               <input
//                 type="text"
//                 placeholder="🔍 Search category..."
//                 value={catSearch}
//                 onChange={e => setCatSearch(e.target.value)}
//               />
//             </div>

//             <div className="fhd-cat-list">
//               {filteredCats.length === 0 ? (
//                 <div style={{textAlign:'center',padding:20,color:'#94a3b8',fontSize:13}}>
//                   No categories found
//                 </div>
//               ) : filteredCats.map((cat, i) => {
//                 const isActive = selectedCategory?.category_id === cat.id;
//                 const count    = assignedMap[cat.id] || 0;
//                 return (
//                   <div
//                     key={i}
//                     className={`fhd-cat-card ${isActive ? 'active' : ''}`}
//                     onClick={() => handleCategoryClick(cat)}
//                   >
//                     {/* Avatar with first letter — same as as-class-avatar */}
//                     <div className="fhd-cat-avatar">
//                       {cat.category?.charAt(0).toUpperCase()}
//                     </div>

//                     <div className="fhd-cat-info">
//                       <div className="fhd-cat-name">{cat.category}</div>
//                       <div className="fhd-cat-sub">
//                         {count > 0 ? `${count} fee head${count > 1 ? 's' : ''} configured` : 'No fee heads yet'}
//                       </div>
//                     </div>

//                     {/* Badge — same as ✓ Set / Empty */}
//                     <span className={`fhd-badge ${count > 0 ? 'set' : 'empty'}`}>
//                       {count > 0 ? `✓ ${count}` : 'Empty'}
//                     </span>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>

//           {/* ══════════════════════════════════════
//               RIGHT PANEL — Manage Fee Heads
//               (same structure as Manage Subjects)
//           ══════════════════════════════════════ */}
//           <div className="fhd-right">

//             {/* Phase 1 — Nothing selected (same as AssignSubjects empty state) */}
//             {!selectedCategory ? (
//               <div className="fhd-empty-state">
//                 <div className="fhd-empty-icon">👈</div>
//                 <div className="fhd-empty-title">Select a category first</div>
//                 <div className="fhd-empty-sub">
//                   Click any category from the left panel<br/>
//                   to assign or manage its fee heads
//                 </div>
//               </div>
//             ) : (
//               <>
//                 {/* Right Header */}
//                 <div className="fhd-right-header">
//                   <div className="fhd-right-header-title">🏷️ {selectedCategory.label}</div>
//                   <div className="fhd-right-header-sub">
//                     {loadingCard
//                       ? 'Loading...'
//                       : `${cardFeeHeads.length} fee head${cardFeeHeads.length !== 1 ? 's' : ''} configured`
//                     }
//                   </div>
//                 </div>

//                 {/* ── Add / Edit Form
//                     Same as "Add New Subjects" section ── */}
//                 <div className="fhd-form-section">
//                   <div className="fhd-form-label-row">
//                     <div className="fhd-form-section-label">
//                       {isEditing ? '✏️ Edit Fee Head' : '➕ Add New Fee Head'}
//                     </div>
//                     {isEditing && (
//                       <div className="fhd-edit-pill">
//                         Editing record
//                         <button onClick={() => setForm(emptyForm)}>×</button>
//                       </div>
//                     )}
//                   </div>

//                   {/* ── Step 1: Group & Shift ── */}
//                   <div className="fhd-step-label">
//                     <span className="step-circle">1</span>
//                     Select Group &amp; Shift
//                   </div>
//                   <div className="fhd-form-grid">

//                     {/* Fee Group */}
//                     <div className="fhd-field">
//                       <label>
//                         <span className="lbl-icon">G</span>
//                         Fee Group <span className="req">*</span>
//                       </label>
//                       <select
//                         className={`fhd-select ${fc('fee_group_id')}`}
//                         value={form.fee_group_id}
//                         onChange={e => {
//                           setForm(f => ({...f, fee_group_id: e.target.value}));
//                           setValidity(v => ({...v, fee_group_id: true}));
//                         }}
//                       >
//                         <option value="">— Select Fee Group —</option>
//                         {getFeeGroups.map((g, i) => (
//                           <option key={i} value={g.id}>{g.fee_group_name}</option>
//                         ))}
//                       </select>
//                       {!validity.fee_group_id && (
//                         <span style={{fontSize:11,color:'#ef4444',marginTop:2}}>⚠ Required</span>
//                       )}
//                     </div>

//                     {/* Shift */}
//                     <div className="fhd-field">
//                       <label>
//                         <span className="lbl-icon">S</span>
//                         Shift <span className="req">*</span>
//                       </label>
//                       <select
//                         className={`fhd-select ${fc('shift')}`}
//                         value={form.shift}
//                         onChange={e => {
//                           setForm(f => ({...f, shift: e.target.value}));
//                           setValidity(v => ({...v, shift: true}));
//                         }}
//                       >
//                         <option value="">— Select Shift —</option>
//                         <option value="Morning">🌤 Morning</option>
//                         <option value="Evening">🌙 Evening</option>
//                       </select>
//                       {!validity.shift && (
//                         <span style={{fontSize:11,color:'#ef4444',marginTop:2}}>⚠ Required</span>
//                       )}
//                     </div>
//                   </div>

//                   <hr className="fhd-form-divider" />

//                   {/* ── Step 2: Fee Head & Amount ── */}
//                   <div className="fhd-step-label">
//                     <span className="step-circle">2</span>
//                     Fee Head &amp; Amount
//                   </div>
//                   <div className="fhd-form-row2">

//                     {/* Fee Head */}
//                     <div className="fhd-field">
//                       <label>
//                         <span className="lbl-icon">H</span>
//                         Fee Head <span className="req">*</span>
//                       </label>
//                       <select
//                         className={`fhd-select ${fc('fee_head_id')}`}
//                         value={form.fee_head_id}
//                         onChange={e => {
//                           setForm(f => ({...f, fee_head_id: e.target.value}));
//                           setValidity(v => ({...v, fee_head_id: true}));
//                         }}
//                       >
//                         <option value="">— Select Fee Head —</option>
//                         {getFeeHeads.map((h, i) => (
//                           <option key={i} value={h.id}>{h.head_name}</option>
//                         ))}
//                       </select>
//                       {!validity.fee_head_id && (
//                         <span style={{fontSize:11,color:'#ef4444',marginTop:2}}>⚠ Required</span>
//                       )}
//                     </div>

//                     {/* Amount */}
//                     <div className="fhd-field">
//                       <label>
//                         <span className="lbl-icon">₨</span>
//                         Amount (PKR) <span className="req">*</span>
//                       </label>
//                       <input
//                         type="number"
//                         min="0"
//                         placeholder="e.g. 5000"
//                         className={`fhd-input ${fc('amount')}`}
//                         value={form.amount}
//                         onChange={e => {
//                           setForm(f => ({...f, amount: e.target.value}));
//                           setValidity(v => ({...v, amount: true}));
//                         }}
//                       />
//                       {!validity.amount && (
//                         <span style={{fontSize:11,color:'#ef4444',marginTop:2}}>⚠ Required</span>
//                       )}
//                     </div>

//                     {/* Buttons */}
//                     <div style={{display:'flex', gap:8, alignItems:'flex-end'}}>
//                       {isEditing && (
//                         <button className="fhd-cancel-btn" onClick={() => setForm(emptyForm)}>
//                           Cancel
//                         </button>
//                       )}
//                       <button
//                         className="fhd-save-btn"
//                         onClick={handleSave}
//                         disabled={saving}
//                       >
//                         <i className={`fas fa-${saving ? 'spinner fa-spin' : isEditing ? 'save' : 'plus-circle'}`} />
//                         {saving ? 'Saving...' : isEditing ? 'Update' : 'Add'}
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 {/* ── Fee Heads List
//                     Same as "Currently Assigned Subjects" section ── */}
//                 <div className="fhd-list-section">
//                   <div className="fhd-list-top">
//                     <div className="fhd-list-label">Assigned Fee Heads</div>
//                     {cardFeeHeads.length > 0 && (
//                       <input
//                         type="text"
//                         className="fhd-search-mini"
//                         placeholder="🔍 Filter..."
//                         value={listSearch}
//                         onChange={e => setListSearch(e.target.value)}
//                       />
//                     )}
//                   </div>

//                   {/* Phase 2 — Loading skeleton */}
//                   {loadingCard ? (
//                     Array(3).fill(0).map((_, i) => (
//                       <div key={i} className="fhd-head-row" style={{gap:12}}>
//                         <div className="fhd-skeleton" style={{width:26,height:26,borderRadius:7,flexShrink:0}}/>
//                         <div style={{flex:1}}>
//                           <div className="fhd-skeleton" style={{width:'60%',marginBottom:6}}/>
//                           <div className="fhd-skeleton" style={{width:'35%',height:10}}/>
//                         </div>
//                         <div className="fhd-skeleton" style={{width:70,height:26,borderRadius:7}}/>
//                       </div>
//                     ))

//                   /* Phase 3a — Empty */
//                   ) : cardFeeHeads.length === 0 ? (
//                     <div className="fhd-no-heads">
//                       No fee heads assigned yet.<br/>
//                       Use the form above to add fee heads for <strong>{selectedCategory.label}</strong>.
//                     </div>

//                   /* Phase 3b — Content (same row as as-subject-row) */
//                   ) : filteredHeads.map((item, index) => (
//                     <div
//                       key={index}
//                       className={`fhd-head-row ${form.hidden_id === item.id ? 'editing' : ''}`}
//                     >
//                       {/* Number — same as as-subject-num */}
//                       <div className="fhd-head-num">{index + 1}</div>

//                       {/* Info */}
//                       <div className="fhd-head-info">
//                         <div className="fhd-head-name">{item.head_name}</div>
//                         <div className="fhd-head-meta" style={{display:'flex',alignItems:'center',gap:6,flexWrap:'wrap'}}>
//                           <span className="fhd-group-tag">
//                             <i className="fas fa-layer-group" style={{fontSize:9}}/>
//                             {item.fee_group_name || '—'}
//                           </span>
//                           <span style={{color:'#cbd5e1'}}>·</span>
//                           <span>
//                             {item.shift === 'Morning' ? '🌤' : '🌙'} {item.shift}
//                           </span>
//                         </div>
//                       </div>

//                       {/* Amount pill */}
//                       <div className="fhd-head-amount">
//                         Rs. {Number(item.amount).toLocaleString()}
//                       </div>

//                       {/* Status badge */}
//                       <span className={`fhd-status-badge ${item.status === 'On' ? 'on' : 'off'}`}>
//                         {item.status === 'On' ? '● Active' : '● Inactive'}
//                       </span>

//                       {/* Actions — same as delete button in AssignSubjects */}
//                       <div className="fhd-row-actions">
//                         <button
//                           className="fhd-action-btn fhd-btn-edit"
//                           onClick={() => handleEdit(item)}
//                           title="Edit this record"
//                         >
//                           <i className="fas fa-pen"/>
//                         </button>
//                         <button
//                           className={`fhd-action-btn ${item.status === 'On' ? 'fhd-btn-toggle-on' : 'fhd-btn-toggle-off'}`}
//                           onClick={() => handleToggle(item.id, item.status)}
//                           title={item.status === 'On' ? 'Deactivate' : 'Activate'}
//                         >
//                           <i className={`fas fa-toggle-${item.status === 'On' ? 'on' : 'off'}`}/>
//                         </button>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </>
//             )}
//           </div>

//         </div>
//       </div>
//     </>
//   );
// }

// export default FeeHeadDetails;



import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import AcademicSessionContext from './AcademicSessionContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FREQ_OPTIONS = [
  { value: 'Monthly',        label: 'Every Month',       icon: '📅' },
  { value: 'OneTime',        label: 'One Time',          icon: '1️⃣' },
  { value: 'SixMonthly',     label: 'Every 6 Months',    icon: '🗓' },
  { value: 'Admission',      label: 'At Admission Only', icon: '🎓' },
];

const FREQ_META = {
  Monthly:    { label: 'Monthly',        bg: '#dbeafe', color: '#1d4ed8' },
  OneTime:    { label: 'One Time',       bg: '#fef9c3', color: '#854d0e' },
  SixMonthly: { label: 'Every 6 Months', bg: '#ede9fe', color: '#4c1d95' },
  Admission:  { label: 'Admission',      bg: '#dcfce7', color: '#15803d' },
};

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');

.fhd-root * { box-sizing:border-box; margin:0; padding:0; }
.fhd-root { font-family:'DM Sans',sans-serif; padding:20px; background:#f6f8fa; min-height:100vh; }

/* ── Layout ── */
.fhd-layout { display:grid; grid-template-columns:280px 1fr; gap:20px; align-items:start; }
@media(max-width:820px){ .fhd-layout{ grid-template-columns:1fr; } }

/* ═══════════════════
   LEFT — Categories
═══════════════════ */
.fhd-left { background:#fff; border:1px solid #e2e8f0; border-radius:12px; overflow:hidden; box-shadow:0 1px 6px rgba(0,0,0,.05); }
.fhd-left-header { background:#064e3b; padding:14px 16px; }
.fhd-left-header h6 { color:#fff; font-size:13.5px; font-weight:700; margin-bottom:2px; }
.fhd-left-header p  { color:rgba(255,255,255,.7); font-size:11.5px; }

.fhd-cat-search { padding:10px 12px; border-bottom:1px solid #f1f5f9; }
.fhd-cat-search input {
  width:100%; border:1px solid #e2e8f0; border-radius:8px;
  padding:7px 12px; font-size:13px; font-family:'DM Sans',sans-serif;
  outline:none; background:#f8fafc; transition:.15s;
}
.fhd-cat-search input:focus { border-color:#064e3b; background:#fff; box-shadow:0 0 0 3px rgba(6,78,59,.1); }

.fhd-cat-list {
  max-height:500px; overflow-y:auto; padding:8px;
  display:flex; flex-direction:column; gap:4px;
  scrollbar-width:thin; scrollbar-color:#a7f3d0 transparent;
}
.fhd-cat-card {
  display:flex; align-items:center; gap:10px;
  padding:9px 11px; border:1px solid #f1f5f9;
  border-radius:9px; cursor:pointer; background:#fff; transition:all .15s;
}
.fhd-cat-card:hover  { border-color:#a7f3d0; background:#f0fdf4; }
.fhd-cat-card.active { border-color:#064e3b; background:#f0fdf4; box-shadow:0 0 0 2px rgba(6,78,59,.1); }
.fhd-cat-avatar {
  width:34px; height:34px; border-radius:8px; background:#064e3b; color:#fff;
  font-size:14px; font-weight:800; display:flex; align-items:center; justify-content:center; flex-shrink:0;
}
.fhd-cat-name { font-size:13px; font-weight:600; color:#1e293b; }
.fhd-cat-sub  { font-size:11px; color:#94a3b8; margin-top:1px; }
.fhd-badge { margin-left:auto; font-size:10px; font-weight:700; padding:2px 8px; border-radius:20px; white-space:nowrap; flex-shrink:0; }
.fhd-badge.set   { background:#d1fae5; color:#065f46; }
.fhd-badge.empty { background:#f1f5f9; color:#94a3b8; }

/* ═══════════════════
   RIGHT — Panel
═══════════════════ */
.fhd-right { background:#fff; border:1px solid #e2e8f0; border-radius:12px; overflow:hidden; box-shadow:0 1px 6px rgba(0,0,0,.05); }
.fhd-empty-state {
  display:flex; flex-direction:column; align-items:center;
  justify-content:center; padding:80px 20px; color:#94a3b8; text-align:center; gap:10px;
}
.fhd-empty-icon  { font-size:44px; opacity:.3; }
.fhd-empty-title { font-size:15px; font-weight:700; color:#64748b; }
.fhd-empty-sub   { font-size:13px; }

.fhd-right-header { background:#064e3b; padding:14px 20px; display:flex; align-items:center; justify-content:space-between; }
.fhd-right-header-title { color:#fff; font-size:14px; font-weight:700; }
.fhd-right-header-sub   { color:rgba(255,255,255,.65); font-size:12px; }

/* ── Form ── */
.fhd-form-section { padding:18px 20px; border-bottom:1px solid #f1f5f9; background:#fafffe; }
.fhd-form-title {
  font-size:11.5px; font-weight:700; color:#064e3b;
  text-transform:uppercase; letter-spacing:.5px;
  margin-bottom:14px; display:flex; align-items:center; justify-content:space-between;
}
.fhd-edit-banner {
  display:flex; align-items:center; gap:8px;
  background:#fffbeb; border:1px solid #fde68a;
  border-radius:8px; padding:8px 12px;
  font-size:12.5px; color:#92400e; font-weight:600; margin-bottom:14px;
}
.fhd-edit-banner button { margin-left:auto; background:none; border:none; color:#92400e; cursor:pointer; font-size:16px; line-height:1; }

/* 2-row form layout */
.fhd-form-row1, .fhd-form-row2 {
  display:grid; gap:12px;
}
.fhd-form-row1 { grid-template-columns:1fr 1fr 1fr; margin-bottom:12px; }
.fhd-form-row2 { grid-template-columns:1fr 1fr auto; }
@media(max-width:640px){
  .fhd-form-row1 { grid-template-columns:1fr 1fr; }
  .fhd-form-row2 { grid-template-columns:1fr 1fr; }
}
@media(max-width:480px){
  .fhd-form-row1, .fhd-form-row2 { grid-template-columns:1fr; }
}

.fhd-field { display:flex; flex-direction:column; gap:5px; }
.fhd-field label { font-size:11.5px; font-weight:600; color:#475569; }
.fhd-field label .req { color:#ef4444; margin-left:2px; }

.fhd-select, .fhd-input {
  padding:9px 12px; border:1px solid #e2e8f0; border-radius:8px;
  font-size:13px; color:#1e293b; background:#fff;
  font-family:'DM Sans',sans-serif; outline:none; transition:.15s;
}
.fhd-select:focus, .fhd-input:focus { border-color:#064e3b; box-shadow:0 0 0 3px rgba(6,78,59,.1); }
.fhd-select.err, .fhd-input.err { border-color:#ef4444; box-shadow:0 0 0 3px rgba(239,68,68,.1); }
.fhd-select.ok,  .fhd-input.ok  { border-color:#10b981; }

/* ── Frequency Radio Cards ── */
.fhd-freq-cards { display:grid; grid-template-columns:repeat(4,1fr); gap:8px; }
@media(max-width:580px){ .fhd-freq-cards{ grid-template-columns:repeat(2,1fr); } }

.fhd-freq-card {
  border:1.5px solid #e2e8f0; border-radius:9px; padding:10px 8px;
  text-align:center; cursor:pointer; transition:all .15s; background:#fff;
  display:flex; flex-direction:column; align-items:center; gap:4px;
  user-select:none;
}
.fhd-freq-card:hover { border-color:#a7f3d0; background:#f0fdf4; }
.fhd-freq-card.selected { border-color:#064e3b; background:#f0fdf4; box-shadow:0 0 0 2px rgba(6,78,59,.12); }
.fhd-freq-card.err-border { border-color:#ef4444; }
.fhd-freq-card .freq-icon { font-size:20px; line-height:1; }
.fhd-freq-card .freq-label { font-size:11.5px; font-weight:700; color:#374151; }
.fhd-freq-card.selected .freq-label { color:#064e3b; }
.fhd-freq-card .freq-check {
  width:16px; height:16px; border-radius:50%; border:2px solid #cbd5e1;
  display:flex; align-items:center; justify-content:center; margin-top:2px;
}
.fhd-freq-card.selected .freq-check { border-color:#064e3b; background:#064e3b; }
.fhd-freq-card.selected .freq-check::after { content:'✓'; font-size:9px; color:#fff; font-weight:800; }

.fhd-save-btn {
  background:#064e3b; color:#fff; border:none; border-radius:9px;
  padding:10px 22px; font-size:13px; font-weight:700;
  cursor:pointer; font-family:'DM Sans',sans-serif;
  white-space:nowrap; display:flex; align-items:center; gap:6px;
  transition:.15s; flex-shrink:0; align-self:flex-end; height:40px;
}
.fhd-save-btn:hover:not(:disabled) { background:#047857; }
.fhd-save-btn:disabled { opacity:.5; cursor:not-allowed; }
.fhd-cancel-btn {
  background:#f1f5f9; color:#64748b; border:none; border-radius:9px;
  padding:10px 16px; font-size:13px; font-weight:700;
  cursor:pointer; font-family:'DM Sans',sans-serif;
  transition:.15s; flex-shrink:0; align-self:flex-end; height:40px;
}
.fhd-cancel-btn:hover { background:#e2e8f0; }

/* ── List Section ── */
.fhd-list-section { padding:16px 20px; }
.fhd-list-top { display:flex; align-items:center; justify-content:space-between; margin-bottom:12px; }
.fhd-list-label { font-size:11px; font-weight:700; color:#94a3b8; text-transform:uppercase; letter-spacing:.6px; }
.fhd-search-mini {
  padding:6px 10px; border:1px solid #e2e8f0; border-radius:8px;
  font-size:12px; font-family:'DM Sans',sans-serif; outline:none; width:160px; transition:.15s;
}
.fhd-search-mini:focus { border-color:#064e3b; box-shadow:0 0 0 3px rgba(6,78,59,.08); }

.fhd-head-row {
  display:flex; align-items:center; gap:10px;
  padding:10px 12px; border:1px solid #f1f5f9;
  border-radius:10px; margin-bottom:6px; background:#fff; transition:.15s;
}
.fhd-head-row:hover   { border-color:#a7f3d0; background:#f9fffe; }
.fhd-head-row.editing { border-color:#fcd34d; background:#fffbeb; }

.fhd-head-num {
  width:26px; height:26px; border-radius:6px; background:#d1fae5; color:#064e3b;
  font-size:11px; font-weight:800; display:flex; align-items:center; justify-content:center; flex-shrink:0;
}
.fhd-head-info { flex:1; min-width:0; }
.fhd-head-name { font-size:13px; font-weight:700; color:#1e293b; }
.fhd-head-meta { display:flex; align-items:center; gap:6px; margin-top:3px; flex-wrap:wrap; }

/* Frequency badge in list */
.fhd-freq-badge {
  display:inline-flex; align-items:center; gap:3px;
  font-size:10.5px; font-weight:700; padding:2px 8px; border-radius:20px;
}
/* Shift badge in list */
.fhd-shift-tag { font-size:11px; color:#94a3b8; display:flex; align-items:center; gap:3px; }

.fhd-head-amount {
  font-size:13px; font-weight:800; color:#064e3b;
  background:#d1fae5; padding:3px 10px; border-radius:7px; flex-shrink:0;
}
.fhd-status-badge { font-size:10.5px; font-weight:700; padding:3px 9px; border-radius:20px; flex-shrink:0; }
.fhd-status-badge.on  { background:#dcfce7; color:#15803d; }
.fhd-status-badge.off { background:#fee2e2; color:#991b1b; }

.fhd-row-actions { display:flex; gap:5px; flex-shrink:0; }
.fhd-action-btn {
  width:28px; height:28px; border:none; border-radius:7px;
  cursor:pointer; display:flex; align-items:center; justify-content:center;
  font-size:12px; transition:.15s;
}
.fhd-action-btn:hover    { transform:scale(1.1); }
.fhd-btn-edit            { background:#d1fae5; color:#064e3b; }
.fhd-btn-toggle-on       { background:#dcfce7; color:#15803d; }
.fhd-btn-toggle-off      { background:#fee2e2; color:#991b1b; }

.fhd-no-heads {
  text-align:center; padding:28px; color:#94a3b8; font-size:13px;
  background:#f9fafb; border-radius:10px; border:1.5px dashed #e2e8f0;
}

/* Skeleton */
.fhd-skeleton {
  border-radius:6px; height:13px;
  background:linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 50%,#f1f5f9 75%);
  background-size:200% 100%; animation:shimmer 1.5s infinite;
}
@keyframes shimmer{ 0%{background-position:200% 0}100%{background-position:-200% 0} }
`;

function FeeHeadDetails() {
  const { user } = useAuth();
  const { academicSession } = useContext(AcademicSessionContext);
  const campus_id = user?.user?.campus_id;

  const [getCategories,    setCategories]    = useState([]);
  const [getFeeHeads,      setFeeHeads]      = useState([]);
  const [getFeeGroups,     setFeeGroups]     = useState([]);
  const [assignedMap,      setAssignedMap]   = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [cardFeeHeads,     setCardFeeHeads]  = useState([]);
  const [loadingCard,      setLoadingCard]   = useState(false);
  const [saving,           setSaving]        = useState(false);
  const [catSearch,        setCatSearch]     = useState('');
  const [listSearch,       setListSearch]    = useState('');

  const emptyForm = { fee_head_id:'', fee_group_id:'', shift:'', amount:'', frequency:'', hidden_id:'' };
  const [form,     setForm]     = useState(emptyForm);
  const [validity, setValidity] = useState({ fee_head_id:true, fee_group_id:true, shift:true, amount:true, frequency:true });
  const isEditing = form.hidden_id !== '';

  // ── Fetch categories ──────────────────────────────
  useEffect(() => {
    if (!campus_id) return;
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/get-categories/${campus_id}`)
      .then(res => setCategories(res.data.results))
      .catch(console.error);
  }, [campus_id]);

  // ── Fetch fee heads ───────────────────────────────
  useEffect(() => {
    if (!campus_id) return;
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-heads/${campus_id}`)
      .then(res => setFeeHeads(res.data.results))
      .catch(console.error);
  }, [campus_id]);

  // ── Fetch fee groups ──────────────────────────────
  useEffect(() => {
    if (!campus_id) return;
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-groups/${campus_id}`)
      .then(res => setFeeGroups(res.data.results))
      .catch(console.error);
  }, [campus_id]);

  // ── Build assignedMap for left badges ────────────
  useEffect(() => {
    if (!campus_id) return;
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-head-details-list`, {
      params: { page:1, limit:500, campus_id }
    }).then(res => {
      const map = {};
      res.data.results.forEach(item => {
        map[item.category_id] = (map[item.category_id] || 0) + 1;
      });
      setAssignedMap(map);
    }).catch(console.error);
  }, [campus_id]);

  // ── Category click ────────────────────────────────
  const handleCategoryClick = (cat) => {
    setSelectedCategory({ category_id: cat.id, label: cat.category });
    setForm(emptyForm);
    setLoadingCard(true);
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-head-details-list`, {
      params: { page:1, limit:200, campus_id, category_id: cat.id }
    }).then(res => {
      setCardFeeHeads(res.data.results);
      setLoadingCard(false);
    }).catch(err => { console.error(err); setLoadingCard(false); });
  };

  // ── Validate ──────────────────────────────────────
  const validate = () => {
    const v = {
      fee_head_id:  !!form.fee_head_id,
      fee_group_id: !!form.fee_group_id,
      shift:        !!form.shift,
      amount:       !!form.amount && String(form.amount).trim() !== '',
      frequency:    !!form.frequency,
    };
    setValidity(v);
    return Object.values(v).every(Boolean);
  };

  // ── Save ──────────────────────────────────────────
  const handleSave = async () => {
    if (!selectedCategory) return;
    if (!validate()) { toast.warning('Please fill all required fields'); return; }
    setSaving(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/insert-fee-head-details`,
        {
          fee_head_id:  form.fee_head_id,
          category_id:  selectedCategory.category_id,
          fee_group_id: form.fee_group_id,
          shift:        form.shift,
          amount:       form.amount,
          frequency:    form.frequency,
          session_id:   parseInt(academicSession),
          campus_id,
          user_id:      user?.user?.user_id,
          hidden_id:    form.hidden_id,
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
      toast.success(isEditing ? '✅ Record updated!' : '✅ Fee head added!');
      setForm(emptyForm);
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/fee-head-details-list`, {
        params: { page:1, limit:200, campus_id, category_id: selectedCategory.category_id }
      });
      setCardFeeHeads(res.data.results);
      setAssignedMap(prev => ({ ...prev, [selectedCategory.category_id]: res.data.results.length }));
    } catch (err) {
      toast.error(err.response?.data?.error || 'Something went wrong');
    }
    setSaving(false);
  };

  // ── Edit ──────────────────────────────────────────
  const handleEdit = (item) => {
    setForm({
      fee_head_id:  item.fee_head_id  || '',
      fee_group_id: item.fee_group_id || '',
      shift:        item.shift        || '',
      amount:       item.amount       || '',
      frequency:    item.frequency    || '',
      hidden_id:    item.id           || '',
    });
    toast.info('✏️ Edit mode — update the form above');
  };

  // ── Toggle ────────────────────────────────────────
  const handleToggle = (id, currentStatus) => {
    setCardFeeHeads(prev =>
      prev.map(item => item.id === id ? { ...item, status: currentStatus === 'On' ? 'Off' : 'On' } : item)
    );
    axios.delete(`${process.env.REACT_APP_API_BASE_URL}/soft-delete-fee-head-details/${id}/${currentStatus}`)
      .catch(() => {
        setCardFeeHeads(prev =>
          prev.map(item => item.id === id ? { ...item, status: currentStatus } : item)
        );
      });
  };

  // ── Filtered lists ────────────────────────────────
  const filteredCats = getCategories.filter(c =>
    c.category?.toLowerCase().includes(catSearch.toLowerCase())
  );
  const filteredHeads = cardFeeHeads.filter(h =>
    h.head_name?.toLowerCase().includes(listSearch.toLowerCase()) ||
    h.shift?.toLowerCase().includes(listSearch.toLowerCase()) ||
    h.fee_group_name?.toLowerCase().includes(listSearch.toLowerCase()) ||
    h.frequency?.toLowerCase().includes(listSearch.toLowerCase())
  );

  const fc = (field) => {
    if (!validity[field]) return 'err';
    if (form[field])      return 'ok';
    return '';
  };

  return (
    <>
      <style>{CSS}</style>
      <div className="fhd-root">
        <div className="fhd-layout">

          {/* ══ LEFT — Category Cards ══ */}
          <div className="fhd-left">
            <div className="fhd-left-header">
              <h6>📂 Categories</h6>
              <p>Click a category to manage its fee heads</p>
            </div>
            <div className="fhd-cat-search">
              <input
                type="text"
                placeholder="🔍 Search category..."
                value={catSearch}
                onChange={e => setCatSearch(e.target.value)}
              />
            </div>
            <div className="fhd-cat-list">
              {filteredCats.length === 0 ? (
                <div style={{textAlign:'center',padding:20,color:'#94a3b8',fontSize:13}}>No categories found</div>
              ) : filteredCats.map((cat, i) => {
                const isActive = selectedCategory?.category_id === cat.id;
                const count    = assignedMap[cat.id] || 0;
                return (
                  <div key={i} className={`fhd-cat-card ${isActive ? 'active' : ''}`} onClick={() => handleCategoryClick(cat)}>
                    <div className="fhd-cat-avatar">{cat.category?.charAt(0).toUpperCase()}</div>
                    <div style={{flex:1,minWidth:0}}>
                      <div className="fhd-cat-name">{cat.category}</div>
                      <div className="fhd-cat-sub">
                        {count > 0 ? `${count} fee head${count > 1 ? 's' : ''} configured` : 'No fee heads yet'}
                      </div>
                    </div>
                    <span className={`fhd-badge ${count > 0 ? 'set' : 'empty'}`}>
                      {count > 0 ? `✓ ${count}` : 'Empty'}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* ══ RIGHT — Manage Panel ══ */}
          <div className="fhd-right">

            {!selectedCategory ? (
              <div className="fhd-empty-state">
                <div className="fhd-empty-icon">👈</div>
                <div className="fhd-empty-title">Select a category first</div>
                <div className="fhd-empty-sub">Click any category from the left panel<br/>to assign or manage its fee heads</div>
              </div>
            ) : (
              <>
                {/* Header */}
                <div className="fhd-right-header">
                  <div className="fhd-right-header-title">🏷️ {selectedCategory.label}</div>
                  <div className="fhd-right-header-sub">
                    {loadingCard ? 'Loading...' : `${cardFeeHeads.length} fee head${cardFeeHeads.length !== 1 ? 's' : ''} configured`}
                  </div>
                </div>

                {/* ── Form ── */}
                <div className="fhd-form-section">

                  <div className="fhd-form-title">
                    {isEditing ? '✏️ Edit Fee Head' : '➕ Add Fee Head'}
                    {isEditing && (
                      <div className="fhd-edit-banner" style={{margin:0,padding:'4px 10px',fontSize:11.5}}>
                        Editing record
                        <button onClick={() => setForm(emptyForm)}>×</button>
                      </div>
                    )}
                  </div>

                  {/* Row 1 — Fee Group, Fee Head, Shift */}
                  <div className="fhd-form-row1">
                    <div className="fhd-field">
                      <label>Fee Group <span className="req">*</span></label>
                      <select
                        className={`fhd-select ${fc('fee_group_id')}`}
                        value={form.fee_group_id}
                        onChange={e => { setForm(f => ({...f, fee_group_id: e.target.value})); setValidity(v => ({...v, fee_group_id:true})); }}
                      >
                        <option value="">— Select Group —</option>
                        {getFeeGroups.map((g, i) => (
                          <option key={i} value={g.id}>{g.fee_group_name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="fhd-field">
                      <label>Fee Head <span className="req">*</span></label>
                      <select
                        className={`fhd-select ${fc('fee_head_id')}`}
                        value={form.fee_head_id}
                        onChange={e => { setForm(f => ({...f, fee_head_id: e.target.value})); setValidity(v => ({...v, fee_head_id:true})); }}
                      >
                        <option value="">— Select Head —</option>
                        {getFeeHeads.map((h, i) => (
                          <option key={i} value={h.id}>{h.head_name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="fhd-field">
                      <label>Shift <span className="req">*</span></label>
                      <select
                        className={`fhd-select ${fc('shift')}`}
                        value={form.shift}
                        onChange={e => { setForm(f => ({...f, shift: e.target.value})); setValidity(v => ({...v, shift:true})); }}
                      >
                        <option value="">— Select Shift —</option>
                        <option value="Morning">🌤 Morning</option>
                        <option value="Evening">🌙 Evening</option>
                      </select>
                    </div>
                  </div>

                  {/* Row 2 — Frequency cards, Amount, Buttons */}
                  <div className="fhd-form-row2">

                    {/* Frequency — spans full width on its own row conceptually */}
                    <div className="fhd-field" style={{gridColumn:'1 / -1'}}>
                      <label>Charge Frequency <span className="req">*</span></label>
                      <div className={`fhd-freq-cards`}>
                        {FREQ_OPTIONS.map(opt => (
                          <div
                            key={opt.value}
                            className={`fhd-freq-card ${form.frequency === opt.value ? 'selected' : ''} ${!validity.frequency && !form.frequency ? 'err-border' : ''}`}
                            onClick={() => { setForm(f => ({...f, frequency: opt.value})); setValidity(v => ({...v, frequency:true})); }}
                          >
                            <span className="freq-icon">{opt.icon}</span>
                            <span className="freq-label">{opt.label}</span>
                            <span className="freq-check" />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Row 3 — Amount + Buttons */}
                  <div style={{display:'flex', gap:12, alignItems:'flex-end', marginTop:12}}>
                    <div className="fhd-field" style={{flex:1, maxWidth:220}}>
                      <label>Amount (PKR) <span className="req">*</span></label>
                      <input
                        type="number"
                        min="0"
                        placeholder="e.g. 5000"
                        className={`fhd-input ${fc('amount')}`}
                        value={form.amount}
                        onChange={e => { setForm(f => ({...f, amount: e.target.value})); setValidity(v => ({...v, amount:true})); }}
                      />
                    </div>
                    <div style={{display:'flex', gap:8}}>
                      {isEditing && (
                        <button className="fhd-cancel-btn" onClick={() => setForm(emptyForm)}>Cancel</button>
                      )}
                      <button className="fhd-save-btn" onClick={handleSave} disabled={saving}>
                        <i className={`fas fa-${saving ? 'spinner fa-spin' : isEditing ? 'save' : 'plus-circle'}`} />
                        {saving ? 'Saving...' : isEditing ? 'Update' : 'Add'}
                      </button>
                    </div>
                  </div>
                </div>

                {/* ── List ── */}
                <div className="fhd-list-section">
                  <div className="fhd-list-top">
                    <div className="fhd-list-label">Assigned Fee Heads</div>
                    {cardFeeHeads.length > 0 && (
                      <input
                        type="text"
                        className="fhd-search-mini"
                        placeholder="🔍 Filter..."
                        value={listSearch}
                        onChange={e => setListSearch(e.target.value)}
                      />
                    )}
                  </div>

                  {loadingCard ? (
                    Array(3).fill(0).map((_, i) => (
                      <div key={i} className="fhd-head-row" style={{gap:12}}>
                        <div className="fhd-skeleton" style={{width:26,height:26,borderRadius:7,flexShrink:0}} />
                        <div style={{flex:1}}>
                          <div className="fhd-skeleton" style={{width:'55%',marginBottom:6}} />
                          <div className="fhd-skeleton" style={{width:'35%',height:10}} />
                        </div>
                        <div className="fhd-skeleton" style={{width:70,height:24,borderRadius:7}} />
                      </div>
                    ))
                  ) : cardFeeHeads.length === 0 ? (
                    <div className="fhd-no-heads">
                      No fee heads assigned yet.<br/>
                      Use the form above to add fee heads for <strong>{selectedCategory.label}</strong>.
                    </div>
                  ) : filteredHeads.map((item, index) => {
                    const freqMeta = FREQ_META[item.frequency] || { label: item.frequency, bg:'#f1f5f9', color:'#64748b' };
                    return (
                      <div key={index} className={`fhd-head-row ${form.hidden_id === item.id ? 'editing' : ''}`}>
                        <div className="fhd-head-num">{index + 1}</div>

                        <div className="fhd-head-info">
                          <div className="fhd-head-name">{item.head_name}</div>
                          <div className="fhd-head-meta">
                            {/* Frequency badge */}
                            <span className="fhd-freq-badge" style={{background: freqMeta.bg, color: freqMeta.color}}>
                              {freqMeta.label}
                            </span>
                            {/* Shift */}
                            <span className="fhd-shift-tag">
                              · {item.shift === 'Morning' ? '🌤' : '🌙'} {item.shift}
                            </span>
                            {/* Group */}
                            {item.fee_group_name && (
                              <span className="fhd-shift-tag">· 📁 {item.fee_group_name}</span>
                            )}
                          </div>
                        </div>

                        <div className="fhd-head-amount">Rs. {Number(item.amount).toLocaleString()}</div>

                        <span className={`fhd-status-badge ${item.status === 'On' ? 'on' : 'off'}`}>
                          ● {item.status === 'On' ? 'Active' : 'Inactive'}
                        </span>

                        <div className="fhd-row-actions">
                          <button className="fhd-action-btn fhd-btn-edit" onClick={() => handleEdit(item)} title="Edit">
                            <i className="fas fa-pen" />
                          </button>
                          <button
                            className={`fhd-action-btn ${item.status === 'On' ? 'fhd-btn-toggle-on' : 'fhd-btn-toggle-off'}`}
                            onClick={() => handleToggle(item.id, item.status)}
                            title={item.status === 'On' ? 'Deactivate' : 'Activate'}
                          >
                            <i className={`fas fa-toggle-${item.status === 'On' ? 'on' : 'off'}`} />
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>

        </div>
      </div>
    </>
  );
}

export default FeeHeadDetails;